var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
///<reference path='../interactive-chat-base/interactive-chat-base-model.d.ts'/>
import { NotifyPropertyChanges, Property, getUniqueID, isNullOrUndefined as isNOU, EventHandler, L10n, remove } from '@syncfusion/ej2-base';
import { Internationalization, ChildProperty, Collection, removeClass, Event, Complex } from '@syncfusion/ej2-base';
import { InterActiveChatBase, ToolbarSettings, ToolbarItem } from '../interactive-chat-base/interactive-chat-base';
import { Toolbar } from '@syncfusion/ej2-navigations';
import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
import { Fab } from '@syncfusion/ej2-buttons';
import { DropDownButton } from '@syncfusion/ej2-splitbuttons';
import { Mention } from '@syncfusion/ej2-dropdowns';
import { Uploader } from '@syncfusion/ej2-inputs';
import { SanitizeHtmlHelper } from '@syncfusion/ej2-base';
export class MessageStatus extends ChildProperty {
}
__decorate([
    Property('')
], MessageStatus.prototype, "iconCss", void 0);
__decorate([
    Property('')
], MessageStatus.prototype, "text", void 0);
__decorate([
    Property('')
], MessageStatus.prototype, "tooltip", void 0);
/**
 * Represents a user model for a messages in the chatUI component.
 */
export class User extends ChildProperty {
}
__decorate([
    Property('')
], User.prototype, "id", void 0);
__decorate([
    Property('Default')
], User.prototype, "user", void 0);
__decorate([
    Property('')
], User.prototype, "avatarUrl", void 0);
__decorate([
    Property('')
], User.prototype, "avatarBgColor", void 0);
__decorate([
    Property('')
], User.prototype, "cssClass", void 0);
__decorate([
    Property('')
], User.prototype, "statusIconCss", void 0);
/**
 * Configures the toolbar displayed on each message in the Chat UI component.
 */
export class MessageToolbarSettings extends ChildProperty {
}
__decorate([
    Property('100%')
], MessageToolbarSettings.prototype, "width", void 0);
__decorate([
    Collection([], ToolbarItem)
], MessageToolbarSettings.prototype, "items", void 0);
__decorate([
    Event()
], MessageToolbarSettings.prototype, "itemClicked", void 0);
/**
 *  Represents a model for a reply messages in the chatUI component.
 */
export class MessageReply extends ChildProperty {
}
__decorate([
    Complex({}, User)
], MessageReply.prototype, "user", void 0);
__decorate([
    Property('')
], MessageReply.prototype, "text", void 0);
__decorate([
    Property([])
], MessageReply.prototype, "mentionUsers", void 0);
__decorate([
    Property('')
], MessageReply.prototype, "messageID", void 0);
__decorate([
    Property('')
], MessageReply.prototype, "timestamp", void 0);
__decorate([
    Property('')
], MessageReply.prototype, "timestampFormat", void 0);
__decorate([
    Property(null)
], MessageReply.prototype, "attachedFile", void 0);
/**
 *  Represents a model for a messages in the chatUI component.
 */
export class Message extends ChildProperty {
}
__decorate([
    Property('')
], Message.prototype, "id", void 0);
__decorate([
    Property('')
], Message.prototype, "text", void 0);
__decorate([
    Complex({}, User)
], Message.prototype, "author", void 0);
__decorate([
    Property('')
], Message.prototype, "timeStamp", void 0);
__decorate([
    Property('')
], Message.prototype, "timeStampFormat", void 0);
__decorate([
    Complex({}, MessageStatus)
], Message.prototype, "status", void 0);
__decorate([
    Property(false)
], Message.prototype, "isPinned", void 0);
__decorate([
    Complex({}, MessageReply)
], Message.prototype, "replyTo", void 0);
__decorate([
    Property(false)
], Message.prototype, "isForwarded", void 0);
__decorate([
    Property(null)
], Message.prototype, "attachedFile", void 0);
__decorate([
    Property([])
], Message.prototype, "mentionUsers", void 0);
export class FileAttachmentSettings extends ChildProperty {
}
__decorate([
    Property('')
], FileAttachmentSettings.prototype, "saveUrl", void 0);
__decorate([
    Property('')
], FileAttachmentSettings.prototype, "removeUrl", void 0);
__decorate([
    Property('')
], FileAttachmentSettings.prototype, "path", void 0);
__decorate([
    Property(Blob)
], FileAttachmentSettings.prototype, "saveFormat", void 0);
__decorate([
    Property('')
], FileAttachmentSettings.prototype, "allowedFileTypes", void 0);
__decorate([
    Property(30000000)
], FileAttachmentSettings.prototype, "maxFileSize", void 0);
__decorate([
    Property(true)
], FileAttachmentSettings.prototype, "enableDragAndDrop", void 0);
__decorate([
    Property(10)
], FileAttachmentSettings.prototype, "maximumCount", void 0);
__decorate([
    Property('')
], FileAttachmentSettings.prototype, "previewTemplate", void 0);
__decorate([
    Property('')
], FileAttachmentSettings.prototype, "attachmentTemplate", void 0);
__decorate([
    Event()
], FileAttachmentSettings.prototype, "attachmentClick", void 0);
let ChatUI = class ChatUI extends InterActiveChatBase {
    /**
     * Constructor for creating the component
     *
     * @param {ChatUIModel} options - Specifies the ChatUIModel model.
     * @param {string | HTMLElement} element - Specifies the element to render as component.
     * @private
     */
    constructor(options, element) {
        super(options, element);
        this.multiplier = 3;
        this.uploadedFiles = [];
    }
    /**
     * Initialize the event handler
     *
     * @private
     * @returns {void}
     */
    preRender() {
        if (!this.element.id) {
            this.element.id = getUniqueID('e-' + this.getModuleName());
        }
    }
    getDirective() {
        return 'EJS-CHATUI';
    }
    /**
     * To get component name.
     *
     * @returns {string} - It returns the current module name.
     * @private
     */
    getModuleName() {
        return 'chat-ui';
    }
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @private
     * @returns {string} - It returns the persisted data.
     */
    getPersistData() {
        return this.addOnPersist([]);
    }
    render() {
        this.renderChatUIView();
    }
    renderChatUIView() {
        this.intl = new Internationalization();
        this.setDimension(this.element, this.width, this.height);
        this.renderViewSections(this.element, 'e-chat-header', 'e-chat-content');
        this.viewWrapper = this.element.querySelector('.e-chat-content');
        this.chatHeader = this.element.querySelector('.e-chat-header');
        this.initializeLocale();
        this.renderChatHeader();
        this.renderChatContentElement();
        this.renderChatSuggestionsElement();
        this.renderChatFooterContent();
        this.addCssClass(this.element, this.cssClass);
        this.addRtlClass(this.element, this.enableRtl);
        this.updateHeader(this.showHeader, this.chatHeader, this.viewWrapper);
        this.updateEmptyChatTemplate();
        this.updateFooterElementClass();
        this.wireEvents();
        this.renderTypingIndicator();
        this.updateScrollPosition(false, 0);
        this.initializeCompactMode();
    }
    initializeLocale() {
        this.l10n = new L10n('chat-ui', {
            oneUserTyping: '{0} is typing',
            twoUserTyping: '{0} and {1} are typing',
            threeUserTyping: '{0}, {1}, and {2} other are typing',
            multipleUsersTyping: '{0}, {1}, and {2} others are typing',
            noRecordsTemplate: 'No records found',
            forwarded: 'Forwarded',
            send: 'Send',
            attachments: 'Attach File',
            close: 'Close',
            download: 'Download',
            filePreview: 'No Preview Available',
            fileCountFailure: 'Upload limit reached: Maximum {0} files allowed. Remove extra files to proceed uploading',
            fileSizeFailure: 'Upload failed: {0} files exceeded the maximum size',
            unpin: 'Unpin',
            viewChat: 'View in Chat'
        }, this.locale);
        this.l10n.setLocale(this.locale);
    }
    updateScrollPosition(isMethodCall, timeDelay) {
        if (this.isReact || this.isAngular) {
            setTimeout(() => {
                if (isMethodCall) {
                    this.handleAutoScroll();
                }
                else {
                    this.scrollToBottom();
                }
            }, timeDelay);
        }
        else {
            this.scrollToBottom();
        }
    }
    renderChatHeader() {
        if (this.headerText) {
            const headerContainer = this.createElement('div', { className: 'e-header' });
            if (this.headerIconCss) {
                const iconElement = this.createElement('span', { className: `e-header-icon e-icons ${this.headerIconCss}` });
                if (this.user.statusIconCss) {
                    iconElement.appendChild(this.chatStatus(this.user.statusIconCss));
                }
                headerContainer.appendChild(iconElement);
            }
            const headerTextElement = this.createElement('div', { className: 'e-header-text' });
            headerTextElement.innerHTML = this.headerText;
            headerContainer.appendChild(headerTextElement);
            this.chatHeader.appendChild(headerContainer);
            this.renderChatHeaderToolbar(headerContainer);
        }
    }
    renderChatHeaderToolbar(headerContainer) {
        if (!isNOU(this.headerToolbar) && this.headerToolbar.items.length > 0) {
            const toolbarEle = this.createElement('div', { className: 'e-chat-toolbar' });
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            const pushToolbar = this.headerToolbar.items.map((item) => ({
                type: item.type,
                template: item.template,
                disabled: item.disabled,
                cssClass: item.cssClass,
                visible: item.visible,
                tooltipText: item.tooltip,
                prefixIcon: item.iconCss,
                text: item.text,
                align: item.align,
                tabIndex: item.tabIndex
            }));
            this.toolbar = new Toolbar({
                items: pushToolbar,
                height: '100%',
                enableRtl: this.enableRtl,
                clicked: (args) => {
                    const eventItemArgs = {
                        type: args.item.type,
                        text: args.item.text,
                        iconCss: args.item.prefixIcon,
                        cssClass: args.item.cssClass,
                        tooltip: args.item.tooltipText,
                        template: args.item.template,
                        disabled: args.item.disabled,
                        visible: args.item.visible,
                        align: args.item.align,
                        tabIndex: args.item.tabIndex
                    };
                    const eventArgs = {
                        item: eventItemArgs,
                        event: args.originalEvent,
                        cancel: false
                    };
                    if (this.headerToolbar.itemClicked) {
                        this.headerToolbar.itemClicked.call(this, eventArgs);
                    }
                }
            });
            if (this.isReact) {
                this.toolbar.isReact = this.isReact;
                this.toolbar.on('render-react-toolbar-template', this.addReactToolbarPortals, this);
            }
            this.toolbar.appendTo(toolbarEle);
            headerContainer.appendChild(toolbarEle);
        }
    }
    addReactToolbarPortals(args) {
        if (this.isReact && args) {
            this.portals = this.portals.concat(args);
        }
    }
    updateHeaderToolbar() {
        const headerContainer = this.chatHeader.querySelector('.e-header');
        if (!isNOU(this.toolbar)) {
            const pushToolbar = this.headerToolbar.items.map((item) => ({
                type: item.type,
                template: item.template,
                disabled: item.disabled,
                cssClass: item.cssClass,
                visible: item.visible,
                tooltipText: item.tooltip,
                prefixIcon: item.iconCss,
                text: item.text,
                align: item.align,
                tabIndex: item.tabIndex
            }));
            this.toolbar.items = pushToolbar;
        }
        else {
            this.renderChatHeaderToolbar(headerContainer);
        }
    }
    renderChatContentElement() {
        this.messageWrapper = this.createElement('div', { className: 'e-message-wrapper', attrs: { 'tabindex': '0' } });
        this.pinnedMessageWrapper = this.createElement('div', { className: 'e-pinned-message-wrapper' });
        this.renderPinnedMessage();
        this.viewWrapper.prepend(this.pinnedMessageWrapper, this.messageWrapper);
        this.content = this.createElement('div', { className: 'e-typing-suggestions' });
        this.viewWrapper.append(this.content);
        this.renderScrollDown();
        this.setChatMsgId();
        this.renderMessageGroup(this.messageWrapper);
    }
    updateEmptyChatTemplate() {
        if (isNOU(this.messages) || this.messages.length <= 0) {
            this.renderBannerView(this.emptyChatTemplate, this.messageWrapper, 'emptyChatTemplate');
            this.isEmptyChatTemplateRendered = isNOU(this.messageWrapper.querySelector('.e-empty-chat-template')) ? false : true;
            if (this.pinnedMessageWrapper) {
                this.pinnedMessageWrapper.style.display = 'none';
            }
        }
    }
    renderChatMessageToolbar(messageItem, msg) {
        const messageOptionsToolbar = this.createElement('div', { className: 'e-chat-message-toolbar' });
        let pushToolbar = [];
        if (this.messageToolbarSettings.items.length > 0) {
            const items = this.messageToolbarSettings.items.filter((item) => {
                const isCopyIcon = item.iconCss.includes('e-chat-copy');
                const hasFileAttachment = this.hasAttachment(msg) && !(this.isImageFile(msg.attachedFile.rawFile));
                if (isCopyIcon && hasFileAttachment) {
                    return false;
                }
                return (item.iconCss !== '' ||
                    item.text !== undefined ||
                    item.type !== 'Button' ||
                    item.align !== 'Left' ||
                    item.visible !== true ||
                    item.disabled !== false ||
                    item.tooltip !== '' ||
                    item.cssClass !== '' ||
                    item.template !== null ||
                    item.tabIndex !== -1);
            });
            pushToolbar = items.map((item) => ({
                type: item.type,
                template: item.template,
                disabled: item.disabled,
                cssClass: item.cssClass,
                visible: item.visible,
                tooltipText: item.tooltip,
                prefixIcon: item.iconCss,
                text: item.text,
                align: item.align,
                width: this.messageToolbarSettings.width,
                tabIndex: item.tabIndex
            }));
        }
        const messageToolbar = new Toolbar({
            items: pushToolbar,
            clicked: (args) => {
                this.handleMessageToolbarClick(args, messageToolbar, messageItem);
            }
        });
        messageToolbar.appendTo(messageOptionsToolbar);
        this.updatePinnedMessage(msg, messageToolbar);
        return messageOptionsToolbar;
    }
    triggerMsgClickedEvent(item, event, message) {
        const eventArgs = {
            item: item,
            event: event,
            cancel: false,
            message: message
        };
        if (this.messageToolbarSettings.itemClicked) {
            this.messageToolbarSettings.itemClicked.call(this, eventArgs);
        }
        return eventArgs;
    }
    handleMessageToolbarClick(args, messageToolbar, messageItem) {
        const messageID = messageItem.id;
        const message = this.messages.find((msg) => msg.id === messageID);
        const eventArgs = this.triggerMsgClickedEvent(args.item, args.originalEvent, message);
        if (!eventArgs.cancel) {
            switch (args.item.prefixIcon) {
                case 'e-icons e-chat-copy':
                    this.handleCopyAction(args, messageToolbar, message);
                    break;
                case 'e-icons e-chat-reply':
                    this.handleReplyAction(message);
                    break;
                case 'e-icons e-chat-trash':
                    this.handleDeleteAction(messageID);
                    break;
                case 'e-icons e-chat-pin':
                case 'e-icons e-chat-unpin':
                    this.togglePin(message, args, messageToolbar);
                    break;
            }
        }
    }
    togglePin(message, args, messageToolbar) {
        const pinnedText = this.pinnedMessageWrapper.querySelector('.e-pinned-message-text');
        const currentlyPinnedId = pinnedText.getAttribute('data-index');
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        if (message.isPinned) {
            message.isPinned = false;
        }
        else {
            if (currentlyPinnedId && currentlyPinnedId !== message.id) {
                this.unpinMessage(currentlyPinnedId);
            }
            message.isPinned = true;
        }
        this.isProtectedOnChange = prevOnChange;
        args.item.prefixIcon = message.isPinned ? 'e-icons e-chat-unpin' : 'e-icons e-chat-pin';
        args.item.tooltipText = message.isPinned ? 'Unpin' : 'Pin';
        messageToolbar.dataBind();
        this.updatePinnedMessage(message, messageToolbar);
    }
    handleDeleteAction(messageID) {
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        const messageToDelete = this.messages.find((msg) => msg.id === messageID);
        if (messageToDelete && messageToDelete.isPinned) {
            this.unpinMessage(messageID);
        }
        this.messages = this.messages.filter((msg) => msg.id !== messageID);
        this.isProtectedOnChange = prevOnChange;
        const messageItem = this.messageWrapper.querySelector(`#${messageID}`);
        if (!messageItem) {
            return;
        }
        const messageGroup = messageItem.closest('.e-message-group');
        if (!messageGroup) {
            return;
        }
        messageGroup.removeChild(messageItem);
        if (messageGroup.querySelector('.e-message-item') === null) {
            this.messageWrapper.removeChild(messageGroup);
        }
        this.cleanupTimeBreaks();
        this.updateEmptyChatTemplate();
    }
    cleanupTimeBreaks() {
        const timeBreaks = Array.from(this.messageWrapper.querySelectorAll('.e-timebreak'));
        let consecutiveBreaks = [];
        timeBreaks.forEach((timeBreak, index) => {
            const nextElement = timeBreak.nextElementSibling;
            // Check if the current time break is the last element or if it's consecutive
            if ((!nextElement || !nextElement.classList.contains('e-timebreak')) && index === timeBreaks.length - 1) {
                this.messageWrapper.removeChild(timeBreak);
            }
            else if (!nextElement || !nextElement.classList.contains('e-timebreak')) {
                if (consecutiveBreaks.length > 0) {
                    consecutiveBreaks.forEach((breakElem) => {
                        this.messageWrapper.removeChild(breakElem);
                    });
                }
                consecutiveBreaks = [];
            }
            else {
                consecutiveBreaks.push(timeBreak);
            }
        });
    }
    handleCopyAction(args, messageToolbar, msg) {
        if (msg.text) {
            this.getClipBoardContent(this.getMessageText(msg));
        }
        if (this.hasAttachment(msg)) {
            const file = msg.attachedFile.rawFile;
            this.writeFileToClipboard(file);
        }
        // Provide feedback to user
        args.item.prefixIcon = 'e-icons e-chat-check';
        messageToolbar.dataBind();
        setTimeout(() => {
            args.item.prefixIcon = 'e-icons e-chat-copy';
            messageToolbar.dataBind();
        }, 1000);
    }
    handleReplyAction(message) {
        let replyWrapper = this.footer.querySelector('.e-reply-wrapper');
        if (!replyWrapper) {
            replyWrapper = this.renderReplyElement(message, true);
            this.footer.prepend(replyWrapper);
        }
        else {
            const userElement = replyWrapper.querySelector('.e-reply-message-user');
            const timeElement = replyWrapper.querySelector('.e-reply-message-time');
            const textElement = replyWrapper.querySelector('.e-reply-message-text');
            if (userElement && textElement) {
                userElement.textContent = message.author.user;
                timeElement.textContent = this.showTimeStamp ? this.getFormattedTime(message.timeStamp, message.timeStampFormat) : '';
                textElement.innerHTML = this.getMessageText(message);
            }
            const previewContainer = replyWrapper.querySelector('.e-reply-media-preview');
            if (previewContainer) {
                previewContainer.remove();
            }
            if (this.hasAttachment(message)) {
                const file = message.attachedFile;
                if (file) {
                    const newReplyContent = this.createFileReplyContent(message);
                    const replyContent = replyWrapper.querySelector('.e-reply-content');
                    if (replyContent) {
                        if (textElement) {
                            replyContent.insertBefore(newReplyContent, textElement);
                        }
                    }
                }
            }
        }
        if (this.editableTextarea) {
            this.setFocusAtEnd(this.editableTextarea);
        }
        this.currentReplyTo = message;
    }
    renderReplyElement(message, withClearIcon = false) {
        if ((!message.replyTo || !message.replyTo.user || (!message.replyTo.text && !message.replyTo.attachedFile)
            || !message.replyTo.messageID) && !withClearIcon) {
            return null;
        }
        const replyWrapper = this.createElement('div', { className: 'e-reply-wrapper' });
        let time;
        let timeStampFormat;
        if (withClearIcon) {
            time = message.timeStamp ? message.timeStamp : new Date();
            timeStampFormat = message.timeStampFormat ? message.timeStampFormat : this.timeStampFormat;
        }
        else {
            time = message.replyTo.timestamp ? message.replyTo.timestamp : new Date();
            timeStampFormat = message.replyTo.timestampFormat ? message.replyTo.timestampFormat : this.timeStampFormat;
        }
        const formattedTime = this.getFormattedTime(time, timeStampFormat);
        const replyContent = this.createElement('div', {
            className: 'e-reply-content',
            innerHTML: `<span class='e-reply-message-text'>${withClearIcon ? this.getMessageText(message) : this.getMessageText(message.replyTo)}</span>`
        });
        const messageDetails = this.createElement('div', {
            className: 'e-reply-message-details',
            innerHTML: `
                <span class='e-reply-message-user'>${withClearIcon ? message.author.user : message.replyTo.user.user}</span>
                <span class='e-reply-message-time'>${this.showTimeStamp ? formattedTime : ''}</span>`
        });
        if (this.hasAttachment(message.replyTo) || this.hasAttachment(message)) {
            const file = withClearIcon ? (this.hasAttachment(message) ? message.attachedFile : null)
                : (this.hasAttachment(message.replyTo) ? message.replyTo.attachedFile : null);
            const sourceMessage = withClearIcon ? message : message.replyTo;
            if (file) {
                const fileReplyContent = this.createFileReplyContent(sourceMessage);
                const textElement = replyContent.querySelector('.e-reply-message-text');
                if (textElement) {
                    replyContent.insertBefore(fileReplyContent, textElement);
                }
            }
        }
        replyContent.prepend(messageDetails);
        if (withClearIcon) {
            const clearIcon = this.createElement('span', {
                className: 'e-chat-close e-icons',
                attrs: { title: this.l10n.getConstant('close') }
            });
            EventHandler.add(clearIcon, 'click', this.clearReplyWrapper.bind(this));
            messageDetails.appendChild(clearIcon);
        }
        else {
            EventHandler.add(replyWrapper, 'click', () => { this.scrollToMessage(message.replyTo.messageID); }, this);
        }
        replyWrapper.prepend(replyContent);
        return replyWrapper;
    }
    createFileReplyContent(message) {
        const fileReplyContent = this.createElement('div', { className: 'e-reply-media-preview' });
        const messageText = this.getMessageText(message);
        const hasText = messageText.trim() !== '';
        const file = message.attachedFile;
        if (this.isImageFile(file.rawFile)) {
            const thumbnailImage = this.createImageContent(file, 'e-reply-media-thumb');
            fileReplyContent.appendChild(thumbnailImage);
        }
        else if (this.isVideoFile(file.rawFile)) {
            const thumbnailvideo = this.createElement('video', {
                attrs: {
                    src: file.fileSource,
                    alt: file.name,
                    disablepictureinpicture: 'true',
                    playsinline: 'true'
                },
                className: 'e-reply-media-thumb'
            });
            fileReplyContent.appendChild(thumbnailvideo);
        }
        else {
            const fileIcon = this.createElement('span', { className: 'e-chat-file-icon e-icons' });
            fileReplyContent.appendChild(fileIcon);
        }
        if (!hasText) {
            const labelElement = this.createElement('span', {
                className: 'e-reply-file-name',
                innerHTML: file.name,
                attrs: { title: file.name }
            });
            fileReplyContent.appendChild(labelElement);
        }
        return fileReplyContent;
    }
    renderPinnedMessage() {
        const pinnedMessage = this.createElement('div', { className: 'e-pinned-message' });
        const pinIcon = this.createElement('span', { className: 'e-icons e-chat-pin' });
        const messageText = this.createElement('span', { className: 'e-pinned-message-text' });
        const pinDropdownButtonEle = this.createElement('button', { id: 'pinnedMessageDropdown' });
        this.dropDownButton = new DropDownButton({
            items: [
                { text: this.l10n.getConstant('viewChat'), iconCss: 'e-icons e-chat-view' },
                { text: this.l10n.getConstant('unpin'), iconCss: 'e-icons e-chat-unpin' }
            ],
            cssClass: 'e-pinned-dropdown-popup e-caret-hide',
            iconCss: 'e-icons e-more-vertical-1',
            select: (args) => {
                const messageId = this.pinnedMessageWrapper.querySelector('.e-pinned-message-text').getAttribute('data-index');
                const message = this.messages.find((msg) => msg.id === messageId);
                // Normalize MenuItem from DropDownButton to ItemModel for consistent event args type
                // This ensures event args always contain ItemModel (matching toolbar item type)
                // and maintains type consistency with handleMessageToolbarClick pattern
                const toolbarItemModel = {
                    text: args.item.text || '',
                    prefixIcon: args.item.iconCss || '',
                    id: args.item.id || ''
                };
                // Fire itemClicked event with normalized ItemModel for consistent event-driven tracking
                const eventArgs = this.triggerMsgClickedEvent(toolbarItemModel, args.event, message);
                // Only execute action if event was not cancelled
                if (!eventArgs.cancel) {
                    if (args.item.text === this.l10n.getConstant('viewChat')) {
                        this.scrollToMessage(messageId);
                    }
                    else if (args.item.text === this.l10n.getConstant('unpin')) {
                        this.unpinMessage(messageId);
                    }
                }
            }
        });
        this.dropDownButton.appendTo(pinDropdownButtonEle);
        pinnedMessage.append(pinIcon, messageText);
        this.pinnedMessageWrapper.append(pinnedMessage, pinDropdownButtonEle);
    }
    updatePinnedMessage(message, messageToolbar) {
        const pinnedText = this.pinnedMessageWrapper.querySelector('.e-pinned-message-text');
        const currentlyPinnedId = pinnedText.getAttribute('data-index');
        if (message.isPinned) {
            if (currentlyPinnedId && currentlyPinnedId !== message.id) {
                const previousMessage = this.messages.find((msg) => msg.id === currentlyPinnedId);
                if (previousMessage) {
                    previousMessage.isPinned = false;
                }
            }
            this.togglePinnedIcon(messageToolbar);
            if (pinnedText) {
                if (this.hasAttachment(message)) {
                    pinnedText.innerHTML = '';
                    this.pinAttachmentMessage(pinnedText, message);
                }
                else {
                    pinnedText.innerHTML = this.getMessageText(message);
                }
                pinnedText.setAttribute('data-index', message.id);
            }
            this.pinnedMessageWrapper.style.display = 'flex';
            this.lastPinnedToolbar = messageToolbar;
        }
        else if (currentlyPinnedId === message.id) {
            this.pinnedMessageWrapper.style.display = 'none';
            this.togglePinnedIcon();
        }
    }
    pinAttachmentMessage(container, message) {
        const file = message.attachedFile;
        if (!file) {
            return;
        }
        let mediaElement;
        if (this.isImageFile(file.rawFile)) {
            mediaElement = this.createImageContent(file, 'e-pinned-img-thumb');
        }
        else if (this.isVideoFile(file.rawFile)) {
            mediaElement = this.createElement('video', {
                attrs: {
                    src: file.fileSource,
                    alt: file.name,
                    disablepictureinpicture: 'true',
                    playsinline: 'true'
                },
                className: 'e-pinned-img-thumb'
            });
        }
        else {
            mediaElement = this.createElement('span', { className: 'e-chat-file-icon e-icons' });
        }
        const messageText = this.getMessageText(message);
        const hasText = messageText.trim() !== '';
        const labelAttrs = {};
        if (!hasText) {
            labelAttrs.title = file.name;
        }
        const pinContent = this.createElement('span', {
            className: hasText ? 'e-pinned-message-content' : 'e-pinned-file-name',
            innerHTML: hasText ? messageText : file.name,
            attrs: labelAttrs
        });
        this.appendChildren(container, mediaElement, pinContent);
    }
    togglePinnedIcon(messageToolbar) {
        if (this.lastPinnedToolbar) {
            this.lastPinnedToolbar.items.forEach((item) => {
                if (item.prefixIcon === 'e-icons e-chat-unpin') {
                    item.prefixIcon = 'e-icons e-chat-pin';
                    item.tooltipText = 'Pin';
                }
            });
            this.lastPinnedToolbar.dataBind();
        }
        if (messageToolbar) {
            messageToolbar.items.forEach((item) => {
                if (item.prefixIcon === 'e-icons e-chat-pin') {
                    item.prefixIcon = 'e-icons e-chat-unpin';
                    item.tooltipText = 'Unpin';
                }
            });
            messageToolbar.dataBind();
            this.lastPinnedToolbar = messageToolbar;
        }
        else {
            this.lastPinnedToolbar = null;
        }
    }
    unpinMessage(messageID) {
        this.pinnedMessageWrapper.style.display = 'none';
        this.togglePinnedIcon();
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        const message = this.messages.find((msg) => msg.id === messageID);
        if (message) {
            message.isPinned = false;
        }
        this.isProtectedOnChange = prevOnChange;
    }
    wireMessageToolbarEvents(messageItem, toolbarEle) {
        EventHandler.add(messageItem, 'mouseover', () => { this.handleMessageMouseEvents(true, messageItem, toolbarEle); }, this);
        EventHandler.add(messageItem, 'mouseleave', () => { this.handleMessageMouseEvents(false, messageItem, toolbarEle); }, this);
    }
    handleMessageMouseEvents(isMouseOver, messageItem, toolbarEle) {
        if (isMouseOver) {
            const isLeftMessage = messageItem.parentElement.classList.contains('e-left');
            toolbarEle.style.visibility = 'hidden';
            toolbarEle.style.display = 'block';
            const toolbarRect = toolbarEle.getBoundingClientRect();
            toolbarEle.style.visibility = '';
            toolbarEle.style.display = 'none';
            const messageContent = this.messageTemplate
                ? messageItem
                : isLeftMessage
                    ? messageItem.querySelector('.e-message-content')
                    : messageItem.querySelector('.e-status-wrapper');
            const messageItemRect = messageItem.getBoundingClientRect();
            const messageContentRect = messageContent.getBoundingClientRect();
            let topPosition = messageContentRect.top - messageItemRect.top - toolbarRect.height;
            if (!isLeftMessage) {
                topPosition += 4; // margin top
            }
            const messageWrapperRect = this.messageWrapper.getBoundingClientRect();
            if (messageContentRect.top - messageWrapperRect.top < toolbarRect.height) {
                topPosition = messageContentRect.bottom - messageItemRect.top;
            }
            toolbarEle.style.top = `${topPosition}px`;
            if (messageContentRect.width < toolbarRect.width && isLeftMessage) {
                toolbarEle.style.left = '0';
                toolbarEle.style.right = 'auto';
            }
            else {
                const statusIconElement = messageContent.querySelector('.e-status-icon');
                const statusIconWidth = statusIconElement ? statusIconElement.getBoundingClientRect().width + 2 : 0;
                const rightPosition = messageItemRect.right - messageContentRect.right + statusIconWidth;
                toolbarEle.style.right = `${rightPosition}px`;
            }
            toolbarEle.style.display = '';
            toolbarEle.classList.add('e-show');
        }
        else {
            toolbarEle.classList.remove('e-show');
        }
    }
    setChatMsgId() {
        if (this.messages && this.messages.length > 0) {
            const prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.messages = this.messages.map((msg, index) => {
                return Object.assign({}, msg, { id: msg.id || `${this.element.id}-message-${index + 1}` });
            });
            this.isProtectedOnChange = prevOnChange;
        }
    }
    renderScrollDown() {
        const scrollDownButton = this.createElement('button', { id: 'scrollDownButton' });
        this.downArrowIcon = new Fab({
            iconCss: 'e-icons e-chat-scroll-down',
            position: 'BottomRight',
            target: this.content,
            isPrimary: false
        });
        this.downArrowIcon.appendTo(scrollDownButton);
    }
    loadBatch() {
        for (let i = this.startIndex - 1; i >= 0; i--) {
            const currIndex = i; // To pass the actual index of the reversed item.
            const prevIndex = i === this.messages.length - 1 ? -1 : currIndex + 1;
            this.updateMessageTimeFormats(this.messages[parseInt(i.toString(), 10)], currIndex);
            const currentMessageDate = this.getMessageDate(currIndex);
            currentMessageDate.setHours(0, 0, 0, 0);
            if (Math.min(currIndex, prevIndex) >= 0) {
                const lastMessageDate = this.getMessageDate(prevIndex);
                lastMessageDate.setHours(0, 0, 0, 0);
                if (currentMessageDate.getTime() === lastMessageDate.getTime()) {
                    const prevTimeBreak = this.messageWrapper.querySelectorAll('.e-timebreak')[0];
                    if (prevTimeBreak) {
                        prevTimeBreak.remove();
                    }
                }
            }
            this.renderGroup(this.messageWrapper, this.messages[parseInt(i.toString(), 10)], true, currIndex, prevIndex);
            if (this.showTimeBreak) {
                this.messageWrapper.prepend(this.createTimebreakElement(currentMessageDate));
            }
            const viewportHeight = window.innerHeight;
            const loadHeight = viewportHeight * this.multiplier;
            this.startIndex = i;
            if (this.messageWrapper.scrollHeight > loadHeight) {
                break;
            }
        }
    }
    renderMessageGroup(chatContentWrapper) {
        if (this.loadOnDemand) {
            if (this.messages && this.messages.length <= 0) {
                return;
            }
            createSpinner({ target: this.messageWrapper });
            this.startIndex = this.messages.length;
            this.loadBatch();
        }
        else {
            this.messages.forEach((msg, i) => {
                this.renderGroup(chatContentWrapper, msg, false, i, i - 1);
            });
        }
    }
    isTimeBreakAdded(chatContentWrapper, loadOldChat) {
        return loadOldChat ?
            chatContentWrapper.firstElementChild.classList.contains('e-timebreak') :
            chatContentWrapper.lastElementChild.classList.contains('e-timebreak');
    }
    getLastUser(prevIndex) {
        if (prevIndex >= 0) {
            return this.messages[parseInt(prevIndex.toString(), 10)].author.id;
        }
        return '';
    }
    initializeCompactMode() {
        this.element.classList.toggle('e-compact-mode', this.enableCompactMode);
    }
    renderGroup(chatContentWrapper, msg, loadOldChat, index, prevIndex, isPrependMessages) {
        let messageGroup;
        if (!loadOldChat) {
            this.updateMessageTimeFormats(msg, index);
            this.handleTimeBreak(prevIndex, index, loadOldChat);
        }
        if (!this.enableCompactMode && msg.author.id === this.user.id) {
            const hasTimeBreak = this.showTimeBreak && this.isTimeBreakAdded(chatContentWrapper, loadOldChat);
            if ((msg.author.id !== this.getLastUser(prevIndex)) || hasTimeBreak) {
                messageGroup = this.createElement('div', { className: `e-message-group e-right ${this.messageTemplate ? 'e-message-item-template' : ''}` });
                this.manageChatContent(loadOldChat, chatContentWrapper, messageGroup);
                this.addGroupItems(msg, messageGroup, false, true, index, loadOldChat);
            }
            else {
                const length = this.element.querySelectorAll('.e-message-group.e-right').length;
                messageGroup = this.element.querySelectorAll('.e-message-group.e-right')[loadOldChat ? 0 : length - 1];
                this.addGroupItems(msg, messageGroup, false, true, index, loadOldChat);
            }
        }
        else {
            if (this.getLastUser(prevIndex) !== msg.author.id || this.isTimeVaries(index, prevIndex)) {
                messageGroup = this.createElement('div', { className: `e-message-group e-left ${this.messageTemplate ? 'e-message-item-template' : ''}` });
                const avatarElement = this.createAvatarIcon(msg.author, false);
                if (!this.messageTemplate) {
                    messageGroup.prepend(avatarElement);
                }
                this.manageChatContent(loadOldChat, chatContentWrapper, messageGroup);
                if (this.loadOnDemand || isPrependMessages) {
                    this.loadLeftGroupOnDemand(msg, loadOldChat, index, messageGroup);
                }
                else {
                    this.createLeftGroupItems(messageGroup, msg);
                    this.addGroupItems(msg, messageGroup, true, false, index, loadOldChat);
                }
            }
            else {
                const length = this.element.querySelectorAll('.e-message-group.e-left').length;
                messageGroup = this.element.querySelectorAll('.e-message-group.e-left')[loadOldChat ? 0 : length - 1];
                if (!loadOldChat) {
                    this.addGroupItems(msg, messageGroup, false, false, index, loadOldChat);
                }
                else {
                    this.loadLeftGroupOnDemand(msg, loadOldChat, index, messageGroup);
                }
            }
        }
    }
    isTimeVaries(index, prevIndex) {
        const currentMessageDate = this.getMessageDate(index);
        currentMessageDate.setHours(0, 0, 0, 0);
        const lastMessageDate = this.getMessageDate(prevIndex);
        lastMessageDate.setHours(0, 0, 0, 0);
        return currentMessageDate.getTime() !== lastMessageDate.getTime();
    }
    loadLeftGroupOnDemand(msg, loadOldChat, index, messageGroup) {
        // To check if the previous author is the same as the current author. If not, create a group header.
        const isAnyMsgPresent = this.messages[parseInt((index - 1).toString(), 10)] ? true : false;
        const prevAuthorId = isAnyMsgPresent ? this.messages[parseInt((index - 1).toString(), 10)].author.id : '';
        const shouldCreateHeader = prevAuthorId !== msg.author.id ? true : false;
        if (shouldCreateHeader || this.isTimeVaries(index, index - 1)) {
            this.addGroupItems(msg, messageGroup, true, false, index, loadOldChat);
            this.createLeftGroupItems(messageGroup, msg);
        }
        else {
            this.addGroupItems(msg, messageGroup, false, false, index, loadOldChat);
        }
    }
    createLeftGroupItems(messageGroup, msg) {
        if (this.messageTemplate) {
            return;
        }
        const userHeaderContainer = this.createElement('div', {
            className: 'e-message-header-container'
        });
        const userHeader = this.createElement('div', {
            className: 'e-message-header'
        });
        userHeader.innerHTML = msg.author.user;
        const timeSpan = this.getTimeStampElement(msg.timeStamp
            ? msg.timeStamp
            : new Date(), msg.timeStampFormat ? msg.timeStampFormat : this.timeStampFormat);
        this.appendChildren(userHeaderContainer, userHeader, timeSpan);
        this.insertBeforeChildren(messageGroup, userHeaderContainer);
    }
    getInitials(name) {
        const nameParts = name.split(' ');
        const initials = nameParts.length > 1
            ? `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`
            : name[0];
        return initials;
    }
    createAvatarIcon(author, isTypingUser) {
        const userName = author.user.trim();
        const initials = this.getInitials(userName);
        const iconClassName = !isTypingUser ? 'e-message-icon' : 'e-user-icon';
        let avatarIcon;
        if (iconClassName === 'e-message-icon') {
            avatarIcon = this.createElement('span', { className: ` ${'e-message-icon'} ${author.cssClass}` });
            if (!isNOU(author.avatarUrl) && author.avatarUrl !== '') {
                const imgElement = this.createElement('img', {
                    attrs: { src: author.avatarUrl, alt: 'Avatar' }
                });
                avatarIcon.appendChild(imgElement);
            }
        }
        else {
            avatarIcon = this.createElement((!isNOU(author.avatarUrl) && author.avatarUrl !== '') ? 'img' : 'span', { className: ` ${'e-user-icon'} ${author.cssClass}` });
        }
        if (author.avatarBgColor) {
            avatarIcon.style.backgroundColor = author.avatarBgColor;
        }
        if (!isNOU(author.avatarUrl) && author.avatarUrl !== '') {
            avatarIcon.src = author.avatarUrl;
            avatarIcon.alt = userName;
        }
        else {
            avatarIcon.innerHTML = initials;
        }
        if (author.statusIconCss && !isTypingUser) {
            avatarIcon.appendChild(this.chatStatus(author.statusIconCss));
        }
        return avatarIcon;
    }
    chatStatus(statusIconCss) {
        let statusTitle;
        // Determine the title based on the statusIconCss
        if (statusIconCss.includes('e-user-online')) {
            statusTitle = 'Available';
        }
        else if (statusIconCss.includes('e-user-away')) {
            statusTitle = 'Away';
        }
        else if (statusIconCss.includes('e-user-busy')) {
            statusTitle = 'Busy';
        }
        else if (statusIconCss.includes('e-user-offline')) {
            statusTitle = 'Offline';
        }
        return this.createElement('span', { className: `e-user-status-icon ${statusIconCss}`,
            attrs: {
                'title': statusTitle
            }
        });
    }
    getTimeStampElement(timeStamp, timeStampFormat) {
        const formattedTime = this.getFormattedTime(timeStamp, timeStampFormat);
        return this.createElement('div', {
            className: 'e-time',
            innerHTML: this.showTimeStamp ? formattedTime : ''
        });
    }
    updateTimeFormats(timeStampFormat, fullTime, index) {
        if (this.messages[parseInt(index.toString(), 10)]) {
            const prevOnChange = this.isProtectedOnChange;
            this.isProtectedOnChange = true;
            this.messages[parseInt(index.toString(), 10)].timeStamp = this.intl.parseDate(fullTime, { format: 'dd/MM/yyyy hh:mm a' });
            this.messages[parseInt(index.toString(), 10)].timeStampFormat = timeStampFormat;
            this.isProtectedOnChange = prevOnChange;
        }
    }
    getFormattedTime(timeStamp, timeStampFormat) {
        timeStamp = typeof timeStamp === 'string' ? new Date(timeStamp) : timeStamp;
        return this.intl.formatDate(timeStamp, { format: this.getFormat(timeStampFormat) });
    }
    getFormat(timeStampFormat) {
        const hasValue = !isNOU(timeStampFormat) && timeStampFormat.length > 0;
        return hasValue ? timeStampFormat
            : (!isNOU(this.timeStampFormat) && this.timeStampFormat.length) ? this.timeStampFormat : 'dd/MM/yyyy hh:mm a';
    }
    renderForwardElement(msg, textElement) {
        if (msg.isForwarded) {
            const forwardedIndicator = this.createElement('div', {
                className: 'e-forwarded-indicator'
            });
            const forwardedMessage = this.createElement('div', {
                className: 'e-forward-message',
                innerHTML: this.l10n.getConstant('forwarded')
            });
            const forwardIcon = this.createElement('span', { className: 'e-icons e-chat-forward' });
            this.appendChildren(forwardedIndicator, forwardIcon, forwardedMessage);
            textElement.prepend(forwardedIndicator);
        }
    }
    getMessageText(msg) {
        const mentionedUsers = msg.mentionUsers;
        if (!isNOU(mentionedUsers) && mentionedUsers.length > 0) {
            // Regular expression to find placeholders like {0}, {10}, {-1}
            const placeholderRegex = /\{(-?\d+)\}/g;
            let messageText = msg.text;
            let match;
            // Find all placeholders in the text
            const placeholders = [];
            // eslint-disable-next-line no-cond-assign
            while ((match = placeholderRegex.exec(messageText)) !== null) {
                placeholders.push({
                    fullMatch: match[0],
                    index: parseInt(match[1], 10)
                });
            }
            // Replace placeholders with user names if the index exists in mentionedUsers
            for (const placeholder of placeholders) {
                const userIndex = placeholder.index;
                // Check if there's a user at this index in the array
                if (userIndex < mentionedUsers.length || (mentionedUsers.length + userIndex) < mentionedUsers.length) {
                    const user = mentionedUsers[parseInt(userIndex.toString(), 10)];
                    if (user) {
                        messageText = messageText.replace(placeholder.fullMatch, this.getMentionChipElement(user));
                    }
                }
            }
            return SanitizeHtmlHelper.sanitize(messageText);
        }
        return SanitizeHtmlHelper.sanitize(msg.text);
    }
    getMentionChipElement(user) {
        const mentionChip = this.createElement('span', { className: 'e-mention-chip' });
        const mentionDisplayEle = this.createElement('span', { className: 'e-chat-mention-user-chip', innerHTML: user.user });
        mentionDisplayEle.setAttribute('data-user-id', user.id);
        mentionChip.append(mentionDisplayEle);
        return mentionChip.outerHTML;
    }
    addGroupItems(msg, messageGroup, isUserTimeStampRendered, showStatus, index, loadOldChat) {
        const messageItem = this.createElement('div', { className: 'e-message-item', id: `${msg.id}` });
        const messageStatusWrapper = this.createElement('div', { className: 'e-status-wrapper' });
        const timeSpan = this.getTimeStampElement(msg.timeStamp ? msg.timeStamp : new Date(), msg.timeStampFormat ? msg.timeStampFormat : this.timeStampFormat);
        const messageContent = this.createElement('div', { className: 'e-message-content' });
        const textElement = this.createElement('div', {
            className: 'e-text',
            innerHTML: this.getMessageText(msg)
        });
        if (this.hasAttachment(msg)) {
            const fileElement = this.createAttachmentContent(msg);
            messageContent.appendChild(fileElement);
        }
        if (!isNOU(textElement) && textElement.innerHTML !== '') {
            messageContent.appendChild(textElement);
        }
        this.updateForwardAndReplyElement(msg, messageContent);
        if (this.messageTemplate) {
            this.getContextObject('messageTemplate', messageItem, index, msg);
        }
        else {
            if (!isUserTimeStampRendered) {
                messageItem.appendChild(timeSpan);
            }
            if (showStatus) {
                const messageElement = this.createElement('div', { className: 'e-status-item' });
                const statusIcon = this.createElement('span', { attrs: { class: `e-status-icon ${msg.status ? msg.status.iconCss : ''}`, title: `${msg.status ? msg.status.tooltip : ''}` } });
                const statusText = this.createElement('div', { innerHTML: msg.status ? msg.status.text : '', className: 'e-status-text' });
                this.appendChildren(messageElement, messageContent, statusIcon);
                this.appendChildren(messageStatusWrapper, messageElement, statusText);
                messageItem.appendChild(messageStatusWrapper);
            }
            else {
                messageItem.appendChild(messageContent);
            }
        }
        this.manageChatContent(loadOldChat, messageGroup, messageItem);
        const toolbarEle = this.renderChatMessageToolbar(messageItem, msg);
        this.wireMessageToolbarEvents(messageItem, toolbarEle);
        messageItem.prepend(toolbarEle);
    }
    createAttachmentContent(msg) {
        const fileElement = this.createElement('div', {
            className: 'e-attached-file'
        });
        const file = msg.attachedFile;
        let wrapper;
        if (this.isImageFile(file.rawFile)) {
            wrapper = this.createElement('div', {
                className: 'e-image-wrapper'
            });
            wrapper.appendChild(this.createImageContent(file, 'e-image'));
            fileElement.appendChild(wrapper);
        }
        else if (this.isVideoFile(file.rawFile)) {
            wrapper = this.createVideoContent(file);
            fileElement.appendChild(wrapper);
        }
        else {
            wrapper = this.createFileItem(msg.attachedFile, false);
            fileElement.appendChild(wrapper);
        }
        EventHandler.add(fileElement, 'click', () => this.handleAttachmentPreview(file, true));
        return fileElement;
    }
    createVideoContent(file) {
        const videoWrapper = this.createElement('div', {
            className: 'e-video-wrapper'
        });
        const videoElement = this.createElement('video', {
            attrs: {
                disablepictureinpicture: 'true',
                playsinline: 'true',
                preload: 'metadata',
                title: file.name
            },
            className: 'e-video'
        });
        const source = this.createElement('source', {
            attrs: {
                src: file.fileSource,
                type: file.rawFile.type
            }
        });
        videoElement.appendChild(source);
        const playIconWrapper = this.createElement('div', {
            className: 'e-play-icon-wrapper'
        });
        const playButton = this.createElement('span', {
            className: 'e-chat-video-play e-icons',
            attrs: {
                role: 'button',
                tabindex: '0',
                'aria-label': 'Play video',
                title: 'Play'
            }
        });
        playIconWrapper.appendChild(playButton);
        videoWrapper.appendChild(videoElement);
        videoWrapper.appendChild(playIconWrapper);
        return videoWrapper;
    }
    updateForwardAndReplyElement(msg, messageContent) {
        if (!msg.isForwarded) {
            const replyElement = this.renderReplyElement(msg, false);
            if (replyElement) {
                messageContent.prepend(replyElement);
            }
        }
        else {
            this.renderForwardElement(msg, messageContent);
        }
    }
    manageChatContent(loadOldChat, parentItem, ChildItem) {
        if (loadOldChat) {
            parentItem.prepend(ChildItem);
        }
        else {
            parentItem.appendChild(ChildItem);
        }
    }
    createTimebreakElement(date) {
        const timebreakDiv = this.createElement('div', { className: `e-timebreak ${this.timeBreakTemplate ? 'e-timebreak-template' : ''}` });
        const formattedTime = this.getFormattedTime(date, 'MMMM d, yyyy');
        if (this.timeBreakTemplate) {
            this.getContextObject('timeBreakTemplate', timebreakDiv, null, null, date);
        }
        else {
            const timeStampEle = this.createElement('span', { className: 'e-timestamp' });
            timeStampEle.innerHTML = formattedTime;
            timebreakDiv.appendChild(timeStampEle);
        }
        return timebreakDiv;
    }
    handleTimeBreak(lastMsgIndex, index, loadOldChat) {
        if (!this.showTimeBreak) {
            return;
        }
        const currentMessageDate = this.getMessageDate(index);
        currentMessageDate.setHours(0, 0, 0, 0);
        if (lastMsgIndex === -1) {
            this.messageWrapper.appendChild(this.createTimebreakElement(currentMessageDate));
        }
        else if (index > 0) {
            const lastMessageDate = this.getMessageDate(lastMsgIndex);
            lastMessageDate.setHours(0, 0, 0, 0);
            if ((currentMessageDate.getTime() !== lastMessageDate.getTime()) && !loadOldChat) {
                this.messageWrapper.appendChild(this.createTimebreakElement(currentMessageDate));
            }
        }
    }
    renderNewMessage(msg, index) {
        if (this.isEmptyChatTemplateRendered) {
            const introContainer = this.messageWrapper.querySelector('.e-empty-chat-template');
            this.messageWrapper.removeChild(introContainer);
            this.isEmptyChatTemplateRendered = false;
        }
        this.renderGroup(this.messageWrapper, msg, false, index, index - 1);
    }
    loadMoreMessages() {
        if (this.startIndex <= 0) {
            return;
        }
        const currentScrollOffset = this.messageWrapper.scrollHeight - this.messageWrapper.scrollTop;
        showSpinner(this.messageWrapper);
        setTimeout(() => {
            hideSpinner(this.messageWrapper);
            this.loadBatch();
            this.messageWrapper.scrollTop = this.messageWrapper.scrollHeight - currentScrollOffset;
        }, 1000);
    }
    updateMessageTimeFormats(msg, index) {
        const fullTime = this.getFormattedTime(msg.timeStamp
            ? msg.timeStamp
            : new Date(), 'dd/MM/yyyy hh:mm a');
        this.updateTimeFormats(msg.timeStampFormat, fullTime, index);
    }
    getMessageDate(index) {
        return new Date(this.messages[parseInt(index.toString(), 10)].timeStamp);
    }
    renderChatSuggestionsElement() {
        if (!isNOU(this.suggestions) && this.suggestions.length > 0) {
            this.renderSuggestions(this.suggestions, null, this.suggestionTemplate, 'suggestion', 'suggestionTemplate', this.onSuggestionClick);
        }
    }
    handleSuggestionUpdate() {
        if (this.suggestionsElement) {
            this.suggestionsElement.remove();
        }
        if (!isNOU(this.suggestions) && this.suggestions.length > 0) {
            this.renderSuggestions(this.suggestions, null, this.suggestionTemplate, 'suggestion', 'suggestionTemplate', this.onSuggestionClick);
        }
        this.toggleScrollIcon();
    }
    onSuggestionClick(e) {
        this.suggestionsElement.hidden = true;
        this.editableTextarea.innerText = e.target.innerText;
        this.onSendIconClick(e);
    }
    renderChatFooterContent() {
        this.getFooter();
        const footerClass = `e-footer ${this.footerTemplate ? 'e-footer-template' : ''}`;
        this.footer.className = footerClass;
        this.renderChatFooter();
        this.viewWrapper.append(this.footer);
        this.updateFooter(this.showFooter, this.footer);
    }
    renderChatFooter() {
        this.renderFooterContent(this.footerTemplate, '', this.placeholder, false, 'e-chat-textarea');
        const sendIconClass = 'e-chat-send e-icons disabled';
        if (!this.footerTemplate) {
            this.renderFooterIcons(sendIconClass, false, '');
            const footerIconsWrapper = this.footer.querySelector('.e-footer-icons-wrapper');
            if (footerIconsWrapper) {
                this.sendIcon.setAttribute('title', this.l10n.getConstant('send'));
                this.updateAttachmentElement(footerIconsWrapper);
            }
            this.refreshTextareaUI();
            this.pushToUndoStack(this.editableTextarea.innerText);
            this.updateMentionObj();
        }
    }
    getMentionDataSource(mentionUsers) {
        const dataSource = mentionUsers.map((user) => {
            const name = user.user.trim();
            const initials = this.getInitials(name);
            return {
                id: user.id,
                user: name,
                avatarUrl: user.avatarUrl || '',
                avatarBgColor: user.avatarBgColor || '',
                cssClass: user.cssClass || '',
                statusIconCss: user.statusIconCss || '',
                initials
            };
        });
        return dataSource;
    }
    initializeMention() {
        // Map UserModel to format expected by Mention component
        const dataSource = this.getMentionDataSource(this.mentionUsers);
        let cssClass = 'e-chat-mention';
        if (this.enableRtl) {
            cssClass += ' e-rtl';
        }
        if (dataSource.length > 0) {
            // Initialize Mention component
            this.mentionObj = new Mention({
                dataSource: dataSource,
                cssClass: cssClass,
                requireLeadingSpace: false,
                suffixText: '&nbsp;',
                noRecordsTemplate: this.l10n.getConstant('noRecordsTemplate'),
                fields: { text: 'user', value: 'id' },
                popupWidth: '250px',
                popupHeight: '200px',
                allowSpaces: true,
                mentionChar: this.mentionTriggerChar,
                displayTemplate: '<span class="e-chat-mention-user-chip" data-user-id="${id}">${user}</span>',
                itemTemplate: '<div class="e-chat-mention-item-template"><span class="e-chat-mention-user-icon ${cssClass}" style="background-color: ${avatarBgColor};">${if(avatarUrl)} <img src="${avatarUrl}" alt="${user}" class="em-img" /> ${else}${initials}${/if} </span><div class="e-chat-mention-user-name">${user}</div></div>',
                select: this.onMentionSelect.bind(this)
            }, this.editableTextarea);
        }
    }
    // Add method to handle mention selection
    onMentionSelect(args) {
        const eventArgs = {
            cancel: false,
            event: args.e,
            isInteracted: args.isInteracted,
            itemData: args.itemData
        };
        this.trigger('mentionSelect', eventArgs);
        args.cancel = eventArgs.cancel;
        this.activateSendIcon(this.editableTextarea.innerText.length);
    }
    hasAttachment(message) {
        return message.attachedFile !== undefined && message.attachedFile !== null;
    }
    isImageFile(file) {
        if (!file) {
            return false;
        }
        return file.type && typeof file.type === 'string' && file.type.startsWith('image/');
    }
    isVideoFile(file) {
        if (!file) {
            return false;
        }
        return file.type && typeof file.type === 'string' && file.type.startsWith('video/');
    }
    updateAttachmentElement(footerIconsWrapper) {
        if (this.enableAttachments) {
            this.renderAttachmentIcon(footerIconsWrapper);
        }
        else {
            if (this.uploaderObj) {
                this.uploaderObj.destroy();
                EventHandler.remove(this.attachmentIcon, 'keydown', this.triggerUploaderAction);
                this.attachmentIcon.innerHTML = '';
                this.dropArea.innerHTML = '';
                this.attachmentIcon.remove();
                remove(this.dropArea);
            }
            this.removeFilesPreview();
        }
    }
    renderAttachmentIcon(footerIconsWrapper) {
        this.dropArea = this.createElement('div', { attrs: { class: 'e-chat-drop-area' } });
        this.footer.prepend(this.dropArea);
        this.attachmentIcon = this.createElement('span', { attrs: { class: 'e-chat-attachment-icon e-icons', role: 'button', 'aria-label': 'Attach files', tabindex: '0', title: this.l10n.getConstant('attachments') } });
        const uploaderElement = this.createElement('input', { attrs: { class: 'e-chat-file-upload', type: 'file', name: 'UploadFiles', id: 'fileUpload' } });
        let dropAreaTarget;
        if (this.attachmentSettings.enableDragAndDrop) {
            dropAreaTarget = this.footer;
        }
        this.uploaderObj = new Uploader({
            asyncSettings: {
                saveUrl: this.attachmentSettings.saveUrl,
                removeUrl: this.attachmentSettings.removeUrl
            },
            maxFileSize: this.attachmentSettings.maxFileSize,
            allowedExtensions: this.attachmentSettings.allowedFileTypes,
            success: this.onUploadSuccess.bind(this),
            failure: this.onUploadFailure.bind(this),
            uploading: this.onUploadStart.bind(this),
            progress: this.onUploadProgress.bind(this),
            multiple: true,
            dropArea: dropAreaTarget,
            selected: (args) => {
                if (args.filesData.some((file) => file.status === this.uploaderObj.l10n.getConstant('invalidFileType'))) {
                    args.cancel = true;
                    return;
                }
                const totalSelected = args.filesData.length + this.uploadedFiles.length;
                if (totalSelected > this.attachmentSettings.maximumCount) {
                    args.cancel = true;
                    this.showFailureAlert('fileCountFailure', this.attachmentSettings.maximumCount, 'e-count-failure');
                    uploaderElement.value = '';
                    return;
                }
                const oversized = args.filesData.filter((file) => file.status === this.uploaderObj.l10n.getConstant('invalidMaxFileSize') && file.statusCode === '0');
                if (oversized.length) {
                    this.showFailureAlert('fileSizeFailure', oversized.length, 'e-size-failure');
                    uploaderElement.value = '';
                }
                this.handleFileSelection(args);
            }
        });
        this.attachmentIcon.appendChild(uploaderElement);
        this.uploaderObj.appendTo(uploaderElement);
        this.attachmentIcon.addEventListener('click', () => uploaderElement.click());
        footerIconsWrapper.prepend(this.attachmentIcon);
        EventHandler.add(this.attachmentIcon, 'keydown', this.triggerUploaderAction, this);
    }
    triggerUploaderAction(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            const uploaderElement = this.footer.querySelector('.e-chat-file-upload');
            if (uploaderElement) {
                uploaderElement.click();
            }
        }
    }
    showFailureAlert(localeConstantKey, fileCount, failureType) {
        let failureMessage = this.l10n.getConstant(localeConstantKey).replace('{0}', fileCount.toString());
        if (fileCount === 1) {
            failureMessage = failureMessage.replace('files', 'file');
        }
        this.createFailureAlert(failureMessage, failureType);
    }
    createFailureAlert(failureMessage, failureType) {
        const failureAlert = this.renderFailureAlert(this.viewWrapper, failureMessage, failureType, 'e-chat-circle-close', 'e-chat-close');
        if (this.viewWrapper.contains(this.footer)) {
            this.viewWrapper.insertBefore(failureAlert, this.footer);
        }
        failureAlert.classList.add('e-show');
        setTimeout(() => {
            this.handleFailureAlertRemove(this.viewWrapper, failureAlert);
        }, 3000);
    }
    handleFileSelection(args) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const fileData of args.filesData) {
                const file = fileData.rawFile;
                if (this.attachmentSettings.path) {
                    fileData.fileSource = `${this.attachmentSettings.path}/${fileData.name}`;
                }
                else if (this.attachmentSettings.saveFormat === 'Base64') {
                    fileData.fileSource = yield this.readFileAsBase64(file);
                }
                else {
                    fileData.fileSource = URL.createObjectURL(file);
                }
            }
            this.element.querySelector('#fileUpload').value = '';
        });
    }
    readFileAsBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }
    onUploadStart(args) {
        this.trigger('beforeAttachmentUpload', args);
        this.uploadedFiles.push(args.fileData);
        const fileItem = this.createFileItem(args.fileData, true);
        this.dropArea.appendChild(fileItem);
    }
    onUploadProgress(args) {
        const uploadProgress = args.e.loaded / args.e.total * 100;
        const progressFill = this.element.querySelector(`#e-chat-progress-${CSS.escape(args.file.name)}`);
        if (progressFill) {
            progressFill.style.width = `${uploadProgress}%`;
        }
    }
    onUploadSuccess(args) {
        if (args.operation === 'upload') {
            this.trigger('attachmentUploadSuccess', args);
            const progressFill = this.element.querySelector(`#e-chat-progress-${CSS.escape(args.file.name)}`);
            if (progressFill) {
                progressFill.style.width = '100%';
                this.cleanupFileItem(args.file.name);
            }
            const progressBar = this.element.querySelector('.e-chat-progress-fill');
            if (!progressBar) {
                this.activateSendIcon(1);
            }
        }
        else if (args.operation === 'remove') {
            this.trigger('attachmentRemoved', args);
        }
    }
    cleanupFileItem(fileName) {
        const fileItem = this.element.querySelector(`#e-chat-progress-${CSS.escape(fileName)}`);
        if (fileItem) {
            fileItem.parentElement.remove();
        }
    }
    onUploadFailure(args) {
        if (args.operation === 'remove') {
            this.trigger('attachmentRemoved', args);
        }
        else {
            this.trigger('attachmentUploadFailure', args);
            this.uploaderObj.remove(args.file);
            this.uploadedFiles = this.uploadedFiles.filter((file) => file.name !== args.file.name);
            const progressFill = this.footer.querySelector(`#e-chat-progress-${CSS.escape(args.file.name)}`);
            if (progressFill) {
                progressFill.style.width = '100%';
                progressFill.classList.add('e-chat-upload-failed');
            }
        }
    }
    createFileItem(fileData, isForFooter) {
        const fileItem = this.createElement('div', { className: isForFooter ? 'e-chat-uploaded-file-item' : 'e-file-wrapper' });
        if (this.attachmentSettings.attachmentTemplate && isForFooter) {
            const introContainer = this.createElement('div', { className: 'e-attachment-template' });
            fileItem.appendChild(introContainer);
            this.getContextObject('attachmenttemplate', introContainer, null, null, null, fileData);
        }
        else {
            const fileIcon = this.createElement('div', { className: 'e-icons e-chat-file-icon' });
            const fileDetails = this.createElement('div', { className: 'e-chat-file-details' });
            const fileName = this.createElement('span', { className: 'e-chat-file-name', innerHTML: fileData.name });
            const fileSize = this.createElement('span', { className: 'e-chat-file-size', innerHTML: `${(fileData.size / 1024).toFixed(2)} KB` });
            fileDetails.append(fileName, fileSize);
            fileItem.append(fileIcon, fileDetails);
        }
        if (isForFooter) {
            const closeButton = this.createElement('span', { attrs: { class: 'e-icons e-chat-close', role: 'button', 'aria-label': 'Clear file', tabindex: '-1' } });
            EventHandler.add(closeButton, 'click', () => this.handleRemoveUploadedFile(closeButton, fileData, fileItem));
            fileItem.append(closeButton);
            const progressBar = this.createElement('div', { className: 'e-chat-progress-bar' });
            const progressFill = this.createElement('div', { id: `e-chat-progress-${fileData.name}`, className: 'e-chat-progress-fill' });
            progressBar.appendChild(progressFill);
            fileItem.append(progressBar);
            EventHandler.add(fileItem, 'click', (event) => {
                if (closeButton && (event.target === closeButton || event.target.classList.contains('e-chat-close'))) {
                    return;
                }
                this.handleAttachmentPreview(fileData, false);
            });
        }
        return fileItem;
    }
    handleRemoveUploadedFile(closeButton, fileData, fileItem) {
        this.uploaderObj.remove(fileData);
        this.uploadedFiles = this.uploadedFiles.filter((file) => file.name !== fileData.name);
        EventHandler.remove(closeButton, 'click', this.handleRemoveUploadedFile);
        fileItem.remove();
        const textLength = this.editableTextarea.innerText.length;
        const totalLength = textLength + this.uploadedFiles.length;
        this.activateSendIcon(totalLength);
    }
    handleAttachmentPreview(file, isAfterPreview) {
        const eventArgs = { cancel: false };
        if (this.attachmentSettings.attachmentClick) {
            this.attachmentSettings.attachmentClick.call(this, eventArgs);
        }
        else if (!eventArgs.cancel) {
            this.showMediaPreview(file, isAfterPreview);
        }
    }
    getFilePreview(file) {
        const sizeInKB = file.size / 1024;
        const sizeDisplay = sizeInKB < 1024 ? `${sizeInKB.toFixed(2)} KB` : `${(sizeInKB / 1024).toFixed(2)} MB`;
        const filePreview = this.createElement('div', {
            className: 'e-file-preview'
        });
        const fileIcon = this.createElement('span', {
            className: 'e-icons e-file-document'
        });
        const previewText = this.createElement('div', {
            className: 'e-preview-file-text',
            innerHTML: this.l10n.getConstant('filePreview')
        });
        const filedetails = this.createElement('div', {
            className: 'e-file-details',
            innerHTML: '' + file.type + ' - ' + sizeDisplay
        });
        this.appendChildren(filePreview, fileIcon, previewText, filedetails);
        return filePreview;
    }
    removeFilesPreview() {
        const previewWrapper = this.messageWrapper.querySelector('.e-preview-overlay');
        if (previewWrapper) {
            previewWrapper.remove();
        }
    }
    renderPreviewTemplate(selectedFile, isAfterPreview) {
        const introContainer = this.createElement('div', { className: 'e-preview-template' });
        let fileIndex;
        if (isAfterPreview) {
            fileIndex = this.messages.findIndex((msg) => msg.attachedFile === selectedFile);
        }
        else {
            fileIndex = Array.isArray(this.uploadedFiles) && selectedFile ?
                this.uploadedFiles.findIndex((fileData) => fileData.id === selectedFile.id) : -1;
        }
        this.getContextObject('previewtemplate', introContainer, fileIndex, null, null, selectedFile);
        return introContainer;
    }
    showMediaPreview(file, isAfterPreview) {
        const previewOverlay = this.createElement('div', {
            className: 'e-preview-overlay',
            attrs: {
                tabindex: '0'
            }
        });
        const previewHeader = this.createElement('div', {
            className: 'e-preview-header'
        });
        const closeButton = this.createElement('span', {
            className: 'e-chat-back-icon e-icons',
            attrs: {
                title: this.l10n.getConstant('close')
            }
        });
        previewHeader.appendChild(closeButton);
        const fileNameLabel = this.createElement('span', {
            className: 'e-preview-file-name',
            innerHTML: file.name
        });
        previewHeader.appendChild(fileNameLabel);
        if (isAfterPreview) {
            const downloadButton = this.createElement('a', {
                className: 'e-chat-download e-icons',
                attrs: {
                    href: file.fileSource,
                    download: file.name,
                    target: '_blank',
                    title: this.l10n.getConstant('download')
                }
            });
            previewHeader.appendChild(downloadButton);
        }
        let previewContent;
        if (this.attachmentSettings.previewTemplate) {
            previewContent = this.renderPreviewTemplate(file, isAfterPreview);
        }
        else {
            if (this.isImageFile(file.rawFile)) {
                previewContent = this.createImageContent(file, 'e-image-preview');
            }
            else if (this.isVideoFile(file.rawFile)) {
                previewContent = this.createElement('video', {
                    attrs: {
                        autoplay: 'true',
                        muted: 'true',
                        controls: 'true',
                        controlsList: 'nodownload noplaybackrate',
                        disablepictureinpicture: 'true',
                        preload: 'metadata',
                        title: file.name
                    },
                    className: 'e-video-preview'
                });
                const source = this.createElement('source', {
                    attrs: {
                        src: file.fileSource,
                        type: file.rawFile.type
                    }
                });
                previewContent.appendChild(source);
            }
            else {
                previewContent = this.getFilePreview(file);
            }
        }
        this.appendChildren(previewOverlay, previewHeader, previewContent);
        this.messageWrapper.appendChild(previewOverlay);
        previewOverlay.focus();
        const escKeyHandler = (event) => {
            if (event.key === 'Escape') {
                closePreview();
            }
        };
        const overlayClickHandler = (event) => {
            if (event.currentTarget === event.target) {
                closePreview();
            }
        };
        const closeClickHandler = () => {
            closePreview();
        };
        const closePreview = () => {
            EventHandler.remove(previewOverlay, 'keydown', escKeyHandler);
            EventHandler.remove(previewOverlay, 'click', overlayClickHandler);
            EventHandler.remove(closeButton, 'click', closeClickHandler);
            previewOverlay.remove();
        };
        EventHandler.add(previewOverlay, 'keydown', escKeyHandler);
        EventHandler.add(previewOverlay, 'click', overlayClickHandler);
        EventHandler.add(closeButton, 'click', closeClickHandler);
    }
    createImageContent(file, imageClass) {
        const imageElement = this.createElement('img', {
            attrs: {
                src: file.fileSource,
                alt: file.name
            },
            className: imageClass
        });
        return imageElement;
    }
    updateAttachmentSettings(newAttachment) {
        this.removeFilesPreview();
        this.uploaderObj.allowedExtensions = !isNOU(newAttachment.allowedFileTypes) ? newAttachment.allowedFileTypes
            : this.attachmentSettings.allowedFileTypes;
        this.uploaderObj.maxFileSize = !isNOU(newAttachment.maxFileSize) ? newAttachment.maxFileSize : this.attachmentSettings.maxFileSize;
        this.uploaderObj.asyncSettings = {
            saveUrl: !isNOU(newAttachment.saveUrl) ? newAttachment.saveUrl : this.attachmentSettings.saveUrl,
            removeUrl: !isNOU(newAttachment.removeUrl) ? newAttachment.removeUrl : this.attachmentSettings.removeUrl
        };
        if (!isNOU(newAttachment.path)) {
            this.attachmentSettings.path = newAttachment.path;
        }
        if (!isNOU(newAttachment.enableDragAndDrop)) {
            this.attachmentSettings.enableDragAndDrop = newAttachment.enableDragAndDrop;
        }
        this.uploaderObj.dropArea = this.attachmentSettings.enableDragAndDrop ? this.footer : '';
        if (!isNOU(newAttachment.saveFormat)) {
            if (newAttachment.saveFormat === 'Base64' || newAttachment.saveFormat === 'Blob') {
                this.attachmentSettings.saveFormat = newAttachment.saveFormat;
            }
        }
        if (!isNOU(newAttachment.maximumCount)) {
            this.attachmentSettings.maximumCount = newAttachment.maximumCount;
        }
    }
    clearUploadedFiles() {
        this.uploadedFiles = [];
        if (this.dropArea) {
            this.dropArea.innerHTML = '';
        }
        this.refreshTextareaUI();
    }
    refreshTextareaUI() {
        const textLength = this.editableTextarea.innerText.length;
        const previewCount = this.uploadedFiles && this.uploadedFiles.length ? this.uploadedFiles.length : 0;
        const totalContent = textLength + previewCount;
        this.updateHiddenTextarea(this.editableTextarea.innerText);
        this.activateSendIcon(totalContent);
        this.updateFooterElementClass();
    }
    handleInput(event) {
        const textareaEle = event.target;
        const isEmpty = textareaEle.innerHTML === '<br>';
        if (isEmpty) {
            this.clearBreakTags(textareaEle);
        }
        const textContent = textareaEle.innerText;
        this.refreshTextareaUI();
        this.editableTextarea.focus();
        // Debounced push to undo stack
        this.scheduleUndoPush();
        this.redoStack = [];
        this.triggerUserTyping(event, textContent);
    }
    onFocusEditableTextarea() {
        if (this.footer) {
            this.footer.classList.add('e-footer-focused');
        }
    }
    onBlurEditableTextarea(e) {
        if (this.footer) {
            this.footer.classList.remove('e-footer-focused');
        }
        this.triggerUserTyping(e, e.target.innerText);
    }
    triggerUserTyping(event, value) {
        const eventArgs = {
            event: event,
            message: value,
            user: this.user,
            isTyping: event.type === 'blur' ? false : value.length > 0 ? true : false
        };
        this.trigger('userTyping', eventArgs);
    }
    renderTypingIndicator() {
        if (this.indicatorWrapper) {
            this.indicatorWrapper.remove();
        }
        if (!this.typingUsers || this.typingUsers.length === 0) {
            return;
        }
        this.indicatorWrapper = this.createElement('div', {
            className: `e-typing-indicator ${this.typingUsersTemplate ? 'e-typing-indicator-template' : ''}`
        });
        if (this.typingUsersTemplate) {
            this.getContextObject('typingUsersTemplate', this.indicatorWrapper, null, null, null);
        }
        else {
            this.typingUsers.slice(0, 3).forEach((user) => {
                const avatarElement = this.createAvatarIcon(user, true);
                this.indicatorWrapper.appendChild(avatarElement);
            });
            const typingMessage = this.createElement('span', { className: 'e-user-text' });
            this.indicatorWrapper.appendChild(typingMessage);
            this.updateUserText();
            const indicatorContainer = this.createElement('div', { className: 'e-indicator-wrapper' });
            for (let i = 0; i < 3; i++) {
                const indicator = this.createElement('span', {
                    className: 'e-indicator'
                });
                this.appendChildren(indicatorContainer, indicator);
            }
            this.indicatorWrapper.appendChild(indicatorContainer);
        }
        this.content.prepend(this.indicatorWrapper);
    }
    updateUserText() {
        if (this.typingUsersTemplate) {
            return;
        }
        const userNames = this.typingUsers.filter((user) => user.user !== this.user.user)
            .map((user) => user.user);
        const displayText = this.getTypingMessage(userNames);
        const typingMessage = this.indicatorWrapper.querySelector('.e-user-text');
        typingMessage.innerHTML = displayText;
    }
    getTypingMessage(userNames) {
        if (userNames.length >= 3) {
            return this.l10n.getConstant(userNames.length > 3 ? 'multipleUsersTyping' : 'threeUserTyping')
                .replace('{0}', userNames[0].toString())
                .replace('{1}', userNames[1].toString())
                .replace('{2}', (userNames.length - 2).toString());
        }
        else {
            const userTemplate = this.l10n.getConstant(userNames.length === 2 ? 'twoUserTyping' : 'oneUserTyping');
            return userNames.length === 2
                ? userTemplate.replace('{0}', userNames[0].toString()).replace('{1}', userNames[1].toString())
                : userTemplate.replace('{0}', userNames[0].toString());
        }
    }
    updateTypingUsers(users) {
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.typingUsers = users;
        this.isProtectedOnChange = prevOnChange;
        this.renderTypingIndicator();
    }
    updateHeaderIcon() {
        const existingIconElement = this.element.querySelector('.e-header-icon');
        if (existingIconElement) {
            existingIconElement.className = `e-header-icon e-icons ${this.headerIconCss}`;
        }
        else {
            const headerContainer = this.element.querySelector('.e-header');
            if (headerContainer) {
                const iconElement = this.createElement('span', {
                    className: `e-header-icon e-icons ${this.headerIconCss}`
                });
                headerContainer.prepend(iconElement);
            }
        }
    }
    updateHeaderText() {
        if (this.headerText) {
            const headerTextEle = this.element.querySelector('.e-header-text');
            if (headerTextEle) {
                headerTextEle.innerHTML = this.headerText;
            }
        }
    }
    renderUpdatedMessage() {
        this.messageWrapper.innerHTML = '';
        this.setChatMsgId();
        this.renderMessageGroup(this.messageWrapper);
        this.updateEmptyChatTemplate();
    }
    getUserMentionFromContent() {
        const mentionChips = this.editableTextarea.querySelectorAll('.e-chat-mention-user-chip');
        const updatedMentionedUsers = [];
        mentionChips.forEach((chip) => {
            const userId = chip.getAttribute('data-user-id');
            const mentionUser = this.mentionUsers.find((user) => user.id === userId);
            if (mentionUser) {
                updatedMentionedUsers.push(mentionUser);
            }
            else {
                const mentionedUser = {
                    id: userId,
                    user: chip.textContent
                };
                updatedMentionedUsers.push(mentionedUser);
            }
        });
        return updatedMentionedUsers;
    }
    onSendIconClick(event) {
        if (this.editableTextarea && this.uploadedFiles.length === 0 && !this.editableTextarea.innerText.trim()) {
            return;
        }
        const repliedTO = this.currentReplyTo ? {
            user: this.currentReplyTo.author,
            text: this.currentReplyTo.text,
            timestamp: this.currentReplyTo.timeStamp,
            timestampFormat: this.currentReplyTo.timeStampFormat,
            messageID: this.currentReplyTo.id,
            mentionUsers: this.currentReplyTo.mentionUsers,
            attachedFile: this.currentReplyTo.attachedFile
        } : null;
        const messageText = this.replaceMentionChipsWithPlaceholders();
        const mentionUsers = this.getUserMentionFromContent();
        const prevOnChange = this.isProtectedOnChange;
        this.editableTextarea.innerText = '';
        this.clearReplyWrapper();
        this.refreshTextareaUI();
        this.pushToUndoStack(this.editableTextarea.innerText);
        this.triggerUserTyping(event, '');
        if (this.uploadedFiles && this.uploadedFiles.length > 0) {
            const filesCount = this.uploadedFiles.length;
            this.uploadedFiles.forEach((file, index) => {
                let newMessageObj = {
                    id: `${this.element.id}-message-${this.messages.length + 1}`,
                    author: this.user,
                    text: index === filesCount - 1 ? messageText : '',
                    mentionUsers: index === filesCount - 1 ? mentionUsers : [],
                    replyTo: index === filesCount - 1 ? repliedTO : null,
                    attachedFile: file
                };
                const eventArgs = {
                    cancel: false,
                    message: newMessageObj
                };
                this.trigger('messageSend', eventArgs, (args) => {
                    if (args.cancel) {
                        return;
                    }
                    newMessageObj = args.message;
                    this.isProtectedOnChange = true;
                    this.messages = [...this.messages, newMessageObj];
                    this.isProtectedOnChange = prevOnChange;
                    this.renderNewMessage(newMessageObj, this.messages.length - 1);
                });
            });
        }
        else {
            let newMessageObj = {
                id: `${this.element.id}-message-${this.messages.length + 1}`,
                author: this.user,
                text: messageText,
                mentionUsers: mentionUsers,
                replyTo: repliedTO,
                attachedFile: null
            };
            const eventArgs = {
                cancel: false,
                message: newMessageObj
            };
            this.trigger('messageSend', eventArgs, (args) => {
                if (args.cancel) {
                    return;
                }
                newMessageObj = args.message;
                this.isProtectedOnChange = true;
                this.messages = [...this.messages, newMessageObj];
                this.isProtectedOnChange = prevOnChange;
                this.renderNewMessage(newMessageObj, this.messages.length - 1);
            });
        }
        if (this.suggestionsElement) {
            this.suggestionsElement.hidden = false;
        }
        // To prevent the issue where scrolling does not move to the bottom in the `messageTemplate` case on Angular and React platforms.
        this.updateScrollPosition(false, 5);
        this.clearUploadedFiles();
    }
    replaceMentionChipsWithPlaceholders() {
        if (!this.editableTextarea.innerHTML) {
            return this.editableTextarea.innerHTML;
        }
        const tempEle = this.createElement('div');
        tempEle.innerHTML = this.editableTextarea.innerHTML;
        const mentionChips = tempEle.querySelectorAll('span.e-mention-chip');
        let mentionIndex = 0;
        mentionChips.forEach((chip) => {
            const placeholder = document.createTextNode(`{${mentionIndex++}}`);
            chip.replaceWith(placeholder);
        });
        return tempEle.innerHTML || '';
    }
    clearReplyWrapper() {
        const replyWrapper = this.footer.querySelector('.e-reply-wrapper');
        if (replyWrapper) {
            const clearIcon = replyWrapper.querySelector('.e-chat-close.e-icons');
            EventHandler.remove(clearIcon, 'click', this.clearReplyWrapper);
            this.footer.removeChild(replyWrapper);
            replyWrapper.remove();
        }
        this.currentReplyTo = null;
    }
    getContextObject(templateName, contentElement, index, message, currentMessagedate, file) {
        let template;
        let context = {};
        switch (templateName.toLowerCase()) {
            case 'messagetemplate': {
                template = this.messageTemplate;
                context = { message: message, index: index };
                break;
            }
            case 'timebreaktemplate': {
                template = this.timeBreakTemplate;
                context = { messageDate: currentMessagedate };
                break;
            }
            case 'typinguserstemplate': {
                template = this.typingUsersTemplate;
                context = { users: this.typingUsers };
                break;
            }
            case 'previewtemplate': {
                template = this.attachmentSettings.previewTemplate;
                context = { selectedFile: file, index: index };
                break;
            }
            case 'attachmenttemplate': {
                template = this.attachmentSettings.attachmentTemplate;
                context = { selectedFile: file };
                break;
            }
        }
        this.updateContent(template, contentElement, context, templateName);
    }
    handleAutoScroll() {
        if (this.isScrollAtBottom) {
            this.updateScroll(this.messageWrapper);
        }
        if (this.autoScrollToBottom) {
            this.updateScroll(this.messageWrapper);
        }
        this.toggleScrollIcon();
    }
    footerKeyHandler(e) {
        const targetElement = e.target;
        if (targetElement.classList.contains('e-chat-attachment-icon')) {
            return;
        }
        this.keyHandler(e, 'footer');
    }
    scrollBottomKeyHandler(e) {
        this.keyHandler(e, 'scrollBottom');
    }
    keyHandler(event, value) {
        if (event.key === 'Enter' && !event.shiftKey) {
            const mentionPopup = document.querySelector('.e-chat-mention.e-mention');
            if (mentionPopup && mentionPopup.classList.contains('e-popup-open')) {
                return;
            }
            switch (value) {
                case 'footer':
                    this.pushToUndoStack(this.editableTextarea.innerText);
                    event.preventDefault();
                    this.onSendIconClick(event);
                    break;
                case 'scrollBottom':
                    this.scrollToBottom();
                    break;
            }
        }
        else {
            this.handleUndoRedo(event);
        }
    }
    applyPromptChange(newState, oldState, event) {
        this.editableTextarea.innerHTML = newState.content;
        this.refreshTextareaUI();
        this.setCursorPosition(newState.selectionStart, newState.selectionEnd);
        this.triggerUserTyping(event, oldState.content);
    }
    updateFooter(showFooter, footerElement) {
        if (!showFooter) {
            footerElement.hidden = true;
        }
        else {
            footerElement.hidden = false;
        }
    }
    handleScroll() {
        this.messageWrapper.querySelectorAll('.e-chat-message-toolbar.e-show').forEach((toolbar) => {
            toolbar.classList.remove('e-show');
        });
        const atBottom = this.checkScrollAtBottom(this.messageWrapper, 0);
        if (atBottom) {
            this.toggleClassName(this.downArrowIcon.element, atBottom, 'downArrow');
            const suggestionEle = this.element.querySelector('.e-suggestions');
            if (suggestionEle) {
                this.toggleClassName(suggestionEle, atBottom, 'suggestion');
                if (!atBottom || !this.isScrollAtBottom) {
                    this.updateScroll(this.messageWrapper);
                }
            }
        }
        if (this.loadOnDemand && this.messageWrapper.scrollTop === 0) {
            this.multiplier += this.multiplier;
            this.loadMoreMessages();
        }
        this.isScrollAtBottom = atBottom;
    }
    toggleClassName(element, atBottom, name) {
        switch (name) {
            case 'downArrow':
                element.classList.toggle('e-arrowdown-hide', atBottom);
                element.classList.toggle('e-arrowdown-show', !atBottom);
                break;
            case 'suggestion':
                element.classList.toggle('e-show-suggestions', atBottom);
                element.classList.toggle('e-hide-suggestions', !atBottom);
                break;
            case 'scroll':
                element.classList.toggle('e-scroll-smooth', !atBottom);
                break;
        }
    }
    toggleScrollIcon() {
        const atBottom = this.checkScrollAtBottom(this.messageWrapper, 0);
        this.toggleClassName(this.downArrowIcon.element, atBottom, 'downArrow');
        const suggestionEle = this.element.querySelector('.e-suggestions');
        if (suggestionEle) {
            this.toggleClassName(suggestionEle, atBottom, 'suggestion');
            if (atBottom) {
                this.updateScroll(this.messageWrapper);
            }
        }
        this.isScrollAtBottom = atBottom;
    }
    scrollBtnClick() {
        this.toggleClassName(this.messageWrapper, false, 'scroll');
        this.scrollToBottom();
        this.toggleClassName(this.messageWrapper, true, 'scroll');
    }
    updateMessageItem(message, msgId) {
        if (message.author || message.timeStamp || this.messageTemplate) {
            this.renderUpdatedMessage();
            return;
        }
        const messageItem = this.messageWrapper.querySelector(`#${msgId}`);
        if (!messageItem) {
            return;
        }
        if (message.id) {
            messageItem.id = message.id;
        }
        const messageContent = messageItem.querySelector('.e-message-content');
        if (messageContent && message.text) {
            const textElement = messageItem.querySelector('.e-text');
            if (textElement) {
                textElement.innerHTML = this.getMessageText(message);
            }
            this.updateForwardAndReplyElement(message, messageContent);
        }
        if (message.status) {
            const statusTextElement = messageItem.querySelector('.e-status-text');
            if (statusTextElement && message.status.text) {
                statusTextElement.innerHTML = message.status.text;
            }
            const statusIconElement = messageItem.querySelector('.e-status-icon');
            if (statusIconElement && message.status.iconCss) {
                const iconCss = message.status.iconCss;
                statusIconElement.className = `e-status-icon ${iconCss}`;
                if (message.status.tooltip) {
                    statusIconElement.title = message.status.tooltip;
                }
            }
        }
    }
    updateMentionObj() {
        if (isNOU(this.mentionObj)) {
            this.initializeMention();
        }
        else {
            if (this.mentionUsers.length > 0) {
                this.mentionObj.dataSource = this.getMentionDataSource(this.mentionUsers);
            }
            else {
                this.destroyAndNullify(this.mentionObj);
                this.mentionObj = null;
            }
        }
    }
    updateLocale() {
        // Updated locale for forward message text.
        this.l10n.setLocale(this.locale);
        const messages = this.messageWrapper.querySelectorAll('.e-message-item');
        messages.forEach((message) => {
            const forwardEle = message.querySelector('.e-forwarded-indicator');
            if (forwardEle) {
                forwardEle.querySelector('.e-forward-message').innerHTML = this.l10n.getConstant('forwarded');
            }
        });
        if (this.mentionObj) {
            this.mentionObj.noRecordsTemplate = this.l10n.getConstant('noRecordsTemplate');
        }
        //update locale for icons
        if (this.sendIcon) {
            this.sendIcon.setAttribute('title', this.l10n.getConstant('send'));
        }
        if (this.attachmentIcon) {
            this.attachmentIcon.setAttribute('title', this.l10n.getConstant('attachments'));
        }
        const closeIcon = this.viewWrapper.querySelector('.e-chat-close');
        if (closeIcon) {
            closeIcon.setAttribute('title', this.l10n.getConstant('close'));
        }
        // Update locale for file preview
        const attachmentPreview = this.viewWrapper.querySelector('.e-preview-overlay');
        if (attachmentPreview) {
            const downloadIcon = attachmentPreview.querySelector('.e-chat-download');
            if (downloadIcon) {
                downloadIcon.setAttribute('title', this.l10n.getConstant('download'));
            }
            const backIcon = attachmentPreview.querySelector('.e-chat-back-icon');
            if (backIcon) {
                backIcon.setAttribute('title', this.l10n.getConstant('close'));
            }
            const filePreviewText = attachmentPreview.querySelector('.e-preview-file-text');
            if (filePreviewText) {
                filePreviewText.textContent = this.l10n.getConstant('filePreview');
            }
        }
        //update locale for failure message
        const failureMessageElem = this.viewWrapper.querySelector('.e-failure-message');
        if (failureMessageElem) {
            if (failureMessageElem.classList.contains('e-size-failure')) {
                failureMessageElem.textContent = this.l10n.getConstant('fileSizeFailure');
            }
            else {
                let failureText = this.l10n.getConstant('fileCountFailure');
                failureText = failureText.replace('{0}', this.attachmentSettings.maximumCount.toString());
                if (this.attachmentSettings.maximumCount === 1) {
                    failureText = failureText.replace('files', 'file');
                }
                failureMessageElem.textContent = failureText;
            }
        }
        // Update locale for typing users text.
        if (!this.typingUsers || this.typingUsers.length === 0) {
            return;
        }
        this.updateUserText();
    }
    wireEvents() {
        this.wireFooterEvents(this.footerTemplate);
        EventHandler.add(this.messageWrapper, 'scroll', this.handleScroll, this);
        EventHandler.add(this.downArrowIcon.element, 'click', this.scrollBtnClick, this);
        EventHandler.add(this.downArrowIcon.element, 'keydown', this.scrollBottomKeyHandler, this);
    }
    unwireEvents() {
        this.unWireFooterEvents(this.footerTemplate);
        EventHandler.remove(this.messageWrapper, 'scroll', this.handleScroll);
        EventHandler.remove(this.downArrowIcon.element, 'click', this.scrollBtnClick);
        EventHandler.remove(this.downArrowIcon.element, 'keydown', this.scrollBottomKeyHandler);
        if (this.attachmentIcon) {
            EventHandler.clearEvents(this.attachmentIcon);
        }
    }
    destroyAttachments() {
        if (this.uploaderObj) {
            this.uploaderObj.destroy();
            this.uploaderObj = null;
        }
        if (this.attachmentIcon) {
            this.attachmentIcon.innerHTML = '';
            this.attachmentIcon.remove();
            this.attachmentIcon = null;
        }
        if (this.dropArea) {
            this.dropArea.innerHTML = '';
            this.dropArea.remove();
            this.dropArea = null;
        }
        if (this.messageWrapper) {
            const previewOverlay = this.messageWrapper.querySelector('.e-preview-overlay');
            if (previewOverlay) {
                previewOverlay.remove();
            }
        }
        this.uploadedFiles = [];
    }
    destroyChatUI() {
        const properties = [
            'content',
            'sendIcon',
            'clearIcon',
            'editableTextarea',
            'footer',
            'indicatorWrapper',
            'messageWrapper',
            'viewWrapper',
            'chatHeader'
        ];
        for (const prop of properties) {
            const element = prop;
            this.removeAndNullify(this[element]);
            this[element] = null;
        }
    }
    /**
     * Scrolls to the last message in the conversation area of the Chat UI component.
     * This method allows programmatic control to ensure the chat view is scrolled to the bottom, typically used when new messages are added or to refocus on the most recent conversation.
     *
     * @returns {void}
     */
    scrollToBottom() {
        this.updateScroll(this.messageWrapper);
        this.toggleScrollIcon();
    }
    /**
     * Appends a new message to the end of the Chat UI conversation area.
     * This method adds the specified message as the latest entry in the chat:
     *
     * @function addMessage
     * @param {string | MessageModel} message - The message to be added to the conversation. Accepts either a plain text string or a `MessageModel` object.
     * - If `message` is a string, a `MessageModel` will be automatically created with the current user’s details, and the message will be appended.
     * - If `message` is an instance of `MessageModel`, it can represent a message from either the current user or another participant and will be appended directly.
     * @returns {void} No return value.
     */
    addMessage(message) {
        if (isNOU(message)) {
            return;
        }
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        if (typeof message === 'string') {
            const newMessageObj = {
                id: `${this.element.id}-message-${this.messages.length + 1}`,
                author: this.user,
                text: message,
                timeStamp: new Date(),
                timeStampFormat: this.timeStampFormat,
                attachedFile: null
            };
            this.messages = [...this.messages, newMessageObj];
            this.renderNewMessage(newMessageObj, (this.messages.length - 1));
        }
        else {
            const newMessageObj = Object.assign({}, message, { id: message.id || `${this.element.id}-message-${this.messages.length + 1}`, author: message.author || this.user, text: message.text || '', timeStamp: message.timeStamp || new Date(), timeStampFormat: message.timeStampFormat || this.timeStampFormat, status: message.status, mentionUsers: message.mentionUsers || [], isPinned: message.isPinned || false, replyTo: message.replyTo, isForwarded: message.isForwarded || false, attachedFile: message.attachedFile });
            this.messages = [...this.messages, newMessageObj];
            this.renderNewMessage(newMessageObj, (this.messages.length - 1));
        }
        // To prevent the issue where scrolling does not move to the bottom in the `messageTemplate` case on Angular and React platforms.
        this.updateScrollPosition(true, 5);
        this.isProtectedOnChange = prevOnChange;
    }
    /**
     * prepends messages to the beginning of the Chat UI conversation area.
     * This method adds the specified messages as the first entries in the chat:
     *
     * @function prependMessages
     * @param {string[] | MessageModel[]} messages - The messages to be added to the conversation. Accepts an array of plain text strings or `MessageModel` objects.
     * - If an element is a string, a `MessageModel` will be automatically created with the current user's details, and the message will be prepended.
     * - If an element is an instance of `MessageModel`, it can represent a message from either the current user or another participant and will be prepended directly.
     * @returns {void} No return value.
     */
    prependMessages(messages) {
        if (isNOU(messages) || messages.length === 0) {
            return;
        }
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        const isEmptyChat = this.messages.length > 0 ? false : true;
        const newMessageObjs = [];
        for (let i = 0; i < messages.length; i++) {
            const message = messages[parseInt(i.toString(), 10)];
            let newMessageObj;
            if (typeof message === 'string') {
                newMessageObj = {
                    id: `${this.element.id}-message-${this.messages.length + i + 1}`,
                    author: this.user,
                    text: message,
                    timeStamp: new Date(),
                    timeStampFormat: this.timeStampFormat,
                    attachedFile: null
                };
            }
            else {
                newMessageObj = Object.assign({}, message, { id: message.id || `${this.element.id}-message-${this.messages.length + i + 1}`, author: message.author || this.user, text: message.text || '', timeStamp: message.timeStamp || new Date(), timeStampFormat: message.timeStampFormat || this.timeStampFormat, status: message.status, mentionUsers: message.mentionUsers || [], isPinned: message.isPinned || false, replyTo: message.replyTo, isForwarded: message.isForwarded || false, attachedFile: message.attachedFile });
            }
            newMessageObjs.push(newMessageObj);
        }
        this.messages = [...newMessageObjs, ...this.messages];
        if (isEmptyChat) {
            for (let i = 0; i < newMessageObjs.length; i++) {
                this.renderNewMessage(newMessageObjs[parseInt(i.toString(), 10)], i);
            }
        }
        else {
            for (let i = newMessageObjs.length - 1; i >= 0; i--) {
                this.renderGroup(this.messageWrapper, newMessageObjs[parseInt(i.toString(), 10)], true, i, -1, true);
            }
        }
        this.isProtectedOnChange = prevOnChange;
    }
    /**
     * Updates an existing message in the Chat UI component.
     * This method allows for modifying a message that has already been added to the conversation.
     * It requires the unique identifier of the message to be updated and the new message content as a `MessageModel`.
     *
     * @function updateMessage
     * @param {MessageModel} message - The updated message content represented as a `MessageModel`.
     * @param {string} msgId - The unique identifier of the message to be updated.
     * @returns {void} No return value.
     */
    updateMessage(message, msgId) {
        const prevOnChange = this.isProtectedOnChange;
        this.isProtectedOnChange = true;
        this.messages = this.messages.map((messageItem) => messageItem.id === msgId ? Object.assign({}, messageItem, message) : messageItem);
        this.updateMessageItem(message, msgId);
        this.isProtectedOnChange = prevOnChange;
    }
    /**
     * Scrolls to a specific message in the Chat UI component based on the provided message ID.
     * Locates the message with the specified ID and scrolls it to the view.
     *
     * @function scrollToMessage
     * @param {string} messageId - The unique identifier of the message to navigate to the corresponding message rendered in the chat UI.
     * @returns {void}.
     */
    scrollToMessage(messageId) {
        const messageElement = this.messageWrapper.querySelector(`#${messageId}`);
        if (!messageElement) {
            return;
        }
        messageElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
    /**
     * Sets focus for the input textarea in the Chat UI component.
     * Ensures that user input is directed to the chat input field.
     *
     * @function focus
     * @returns {void}.
     */
    focus() {
        if (this.editableTextarea) {
            this.setFocusAtEnd(this.editableTextarea);
        }
    }
    destroy() {
        super.destroy();
        this.unwireEvents();
        if (this.toolbar) {
            this.toolbar.off('render-react-toolbar-template', this.addReactToolbarPortals);
        }
        if (this.cssClass) {
            removeClass([this.element], this.cssClass.split(' '));
        }
        this.element.classList.remove('e-rtl');
        this.destroyAndNullify(this.downArrowIcon);
        this.destroyAndNullify(this.toolbar);
        this.destroyAndNullify(this.dropDownButton);
        this.destroyAndNullify(this.mentionObj);
        this.destroyChatUI();
        this.destroyAttachments();
        this.intl = null;
    }
    /**
     * Called if any of the property value is changed.
     *
     * @param  {ChatUIModel} newProp - Specifies new properties
     * @param  {ChatUIModel} oldProp - Specifies old properties
     * @returns {void}
     * @private
     */
    onPropertyChanged(newProp, oldProp) {
        for (const prop of Object.keys(newProp)) {
            switch (prop) {
                case 'width':
                case 'height':
                    this.setDimension(this.element, this.width, this.height);
                    break;
                case 'placeholder':
                    this.updatePlaceholder(this.placeholder);
                    break;
                case 'cssClass':
                    this.updateCssClass(this.element, newProp.cssClass, oldProp.cssClass);
                    break;
                case 'enableRtl':
                    this.element.classList[this.enableRtl ? 'add' : 'remove']('e-rtl');
                    if (!isNOU(this.toolbar)) {
                        this.toolbar.enableRtl = this.enableRtl;
                        this.toolbar.dataBind();
                    }
                    break;
                case 'showHeader':
                    this.updateHeader(this.showHeader, this.chatHeader, this.viewWrapper);
                    break;
                case 'enableCompactMode':
                    this.initializeCompactMode();
                    this.renderUpdatedMessage();
                    this.updateScrollPosition(true, 5);
                    break;
                case 'headerText':
                    this.updateHeaderText();
                    break;
                case 'headerIconCss':
                    this.updateHeaderIcon();
                    break;
                case 'messageToolbarSettings':
                case 'messages': {
                    this.renderUpdatedMessage();
                    // To prevent the issue where scrolling does not move to the bottom in the `messageTemplate` case on Angular and React platforms.
                    this.updateScrollPosition(true, 5);
                    break;
                }
                case 'user': {
                    const newUser = {
                        id: newProp.user.id ? newProp.user.id : this.user.id,
                        user: newProp.user.user ? newProp.user.user : this.user.user,
                        avatarUrl: newProp.user.avatarUrl ? newProp.user.avatarUrl : this.user.avatarUrl,
                        avatarBgColor: newProp.user.avatarBgColor ? newProp.user.avatarBgColor : this.user.avatarBgColor,
                        cssClass: newProp.user.cssClass ? newProp.user.cssClass : this.user.cssClass,
                        statusIconCss: newProp.user.statusIconCss ? newProp.user.statusIconCss : this.user.statusIconCss
                    };
                    this.user = Object.assign({}, this.user, newUser);
                    break;
                }
                case 'showTimeStamp':
                case 'timeStampFormat':
                case 'showTimeBreak':
                    if (this.messages.length > 0) {
                        this.renderUpdatedMessage();
                    }
                    break;
                case 'showFooter':
                    this.updateFooter(this.showFooter, this.footer);
                    break;
                case 'autoScrollToBottom':
                    this.handleAutoScroll();
                    break;
                case 'suggestions':
                    this.handleSuggestionUpdate();
                    break;
                case 'typingUsers':
                    this.updateTypingUsers(this.typingUsers);
                    break;
                case 'locale':
                    this.updateLocale();
                    break;
                case 'currencyCode':
                    this.refresh();
                    break;
                case 'mentionTriggerChar':
                    this.mentionObj.mentionChar = newProp.mentionTriggerChar;
                    break;
                case 'mentionUsers':
                    this.updateMentionObj();
                    break;
                case 'enableAttachments':
                    if (!this.footerTemplate) {
                        const footerIconsWrapper = this.element.querySelector('.e-footer-icons-wrapper');
                        this.updateAttachmentElement(footerIconsWrapper);
                    }
                    break;
                case 'attachmentSettings':
                    this.updateAttachmentSettings(newProp.attachmentSettings);
                    break;
            }
        }
    }
};
__decorate([
    Property('100%')
], ChatUI.prototype, "width", void 0);
__decorate([
    Property('100%')
], ChatUI.prototype, "height", void 0);
__decorate([
    Complex({}, User)
], ChatUI.prototype, "user", void 0);
__decorate([
    Property('Chat')
], ChatUI.prototype, "headerText", void 0);
__decorate([
    Property('')
], ChatUI.prototype, "headerIconCss", void 0);
__decorate([
    Property('Type your message…')
], ChatUI.prototype, "placeholder", void 0);
__decorate([
    Property('')
], ChatUI.prototype, "cssClass", void 0);
__decorate([
    Property(true)
], ChatUI.prototype, "showHeader", void 0);
__decorate([
    Property(true)
], ChatUI.prototype, "showFooter", void 0);
__decorate([
    Complex({ items: [] }, ToolbarSettings)
], ChatUI.prototype, "headerToolbar", void 0);
__decorate([
    Property([])
], ChatUI.prototype, "suggestions", void 0);
__decorate([
    Property(false)
], ChatUI.prototype, "showTimeBreak", void 0);
__decorate([
    Collection([], Message)
], ChatUI.prototype, "messages", void 0);
__decorate([
    Collection([], User)
], ChatUI.prototype, "typingUsers", void 0);
__decorate([
    Property('dd/MM/yyyy hh:mm a')
], ChatUI.prototype, "timeStampFormat", void 0);
__decorate([
    Property(true)
], ChatUI.prototype, "showTimeStamp", void 0);
__decorate([
    Property(false)
], ChatUI.prototype, "autoScrollToBottom", void 0);
__decorate([
    Property(false)
], ChatUI.prototype, "loadOnDemand", void 0);
__decorate([
    Collection([], User)
], ChatUI.prototype, "mentionUsers", void 0);
__decorate([
    Property('@')
], ChatUI.prototype, "mentionTriggerChar", void 0);
__decorate([
    Property('')
], ChatUI.prototype, "suggestionTemplate", void 0);
__decorate([
    Property('')
], ChatUI.prototype, "footerTemplate", void 0);
__decorate([
    Property('')
], ChatUI.prototype, "emptyChatTemplate", void 0);
__decorate([
    Property('')
], ChatUI.prototype, "messageTemplate", void 0);
__decorate([
    Property('')
], ChatUI.prototype, "timeBreakTemplate", void 0);
__decorate([
    Property('')
], ChatUI.prototype, "typingUsersTemplate", void 0);
__decorate([
    Property(false)
], ChatUI.prototype, "enableCompactMode", void 0);
__decorate([
    Complex({ width: '100%', items: [{ iconCss: 'e-icons e-chat-copy', tooltip: 'Copy' }, { iconCss: 'e-icons e-chat-reply', tooltip: 'Reply' }, { iconCss: 'e-icons e-chat-pin', tooltip: 'Pin' }, { iconCss: 'e-icons e-chat-trash', tooltip: 'Delete' }] }, MessageToolbarSettings)
], ChatUI.prototype, "messageToolbarSettings", void 0);
__decorate([
    Event()
], ChatUI.prototype, "messageSend", void 0);
__decorate([
    Event()
], ChatUI.prototype, "userTyping", void 0);
__decorate([
    Event()
], ChatUI.prototype, "mentionSelect", void 0);
__decorate([
    Property(false)
], ChatUI.prototype, "enableAttachments", void 0);
__decorate([
    Complex({ saveUrl: '', removeUrl: '', maxFileSize: 30000000, allowedFileTypes: '', saveFormat: 'Blob', path: '', enableDragAndDrop: true, maximumCount: 10, previewTemplate: '', attachmentTemplate: '' }, FileAttachmentSettings)
], ChatUI.prototype, "attachmentSettings", void 0);
__decorate([
    Event()
], ChatUI.prototype, "beforeAttachmentUpload", void 0);
__decorate([
    Event()
], ChatUI.prototype, "attachmentUploadSuccess", void 0);
__decorate([
    Event()
], ChatUI.prototype, "attachmentUploadFailure", void 0);
__decorate([
    Event()
], ChatUI.prototype, "attachmentRemoved", void 0);
ChatUI = __decorate([
    NotifyPropertyChanges
], ChatUI);
export { ChatUI };
